(function () {
  'use strict';
  // Temporary flag: when true, "I need a basic design" only shows the main product (generalized design form)
  const DESIGN_FORM_MAIN_ONLY = false;

  window.toggleSimpleMode = function(checkbox, itemCode) {
    window._designFormSimpleModes = window._designFormSimpleModes || {};
    window._designFormSimpleModes[itemCode] = !checkbox.checked;
    
    const container = checkbox.closest('.ds-design-form-accordions') || document.getElementById('design-sidebar-body');
    if (container) {
      _loadBasicDesignMode(container, itemCode).then(() => {
        if (window._hydrateSavedAccordion) {
          window._hydrateSavedAccordion(container);
        }
      });
    }
  };



  // State
  window._designSidebar = {
    mode: null,
    pendingFiles: new Map(),
    selectedAddons: [],
    productData: null,
    bundleData: null,
    questionsData: null,
    generatedDesignUrls: new Map(),
    autosaveTimer: null,
    autosaveDelayMs: 1200,
    designFormIndex: 0,
  };

  function _fetchNextDesignFormIndex() {
    const args = {};
    const cartQuotation = frappe.get_cookie('cart_quotation');
    if (cartQuotation) args.quotation_name = cartQuotation;
    
    frappe.call({
        method: 'klaviyo_integration.apis.design_form_utils.get_next_design_form_index',
        args: args,
        async: false,
        callback: function(r) {
            if (r && r.message) {
                window._designSidebar.designFormIndex = r.message;
            } else {
                window._designSidebar.designFormIndex = Date.now() % 900000 + 100000;
            }
        },
        error: function() {
            window._designSidebar.designFormIndex = Date.now() % 900000 + 100000;
        }
    });
  }

  // Open / Close
  window.openDesignSidebar = function (mode) {
    const sidebar = document.getElementById('design-sidebar');
    const overlay = document.getElementById('design-sidebar-overlay');
    if (!sidebar || !overlay) return;

    window._designSidebar.mode = mode;
    window._designSidebar.pendingFiles = new Map();
    window._designSidebar.generatedDesignUrls = new Map();
    window._designSidebar.selectedAddons = _getSelectedAddons();
    if (!window._designSidebar.designFormIndex) {
        _fetchNextDesignFormIndex();
    }
    if (window._designSidebar.autosaveTimer) {
      clearTimeout(window._designSidebar.autosaveTimer);
      window._designSidebar.autosaveTimer = null;
    }

    // Highlight active button
    document.querySelectorAll('.design-choice-btn').forEach(b => b.classList.remove('active'));
    const activeBtn = document.querySelector(`.design-choice-btn[data-mode="${mode}"]`);
    if (activeBtn) activeBtn.classList.add('active');
    
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      if (url.searchParams.get('mode') !== mode) {
        url.searchParams.set('mode', mode);
        window.history.replaceState({}, '', url);
      }
    }

    sidebar.style.display = 'flex';
    overlay.style.display = 'block';
    requestAnimationFrame(() => sidebar.classList.add('open'));

    // Set title
    const titles = {
      artwork: 'Upload Artwork',
      basic_design: 'Design Form',
      custom_quote: 'Request Custom Quote'
    };
    document.getElementById('design-sidebar-title').textContent = titles[mode] || 'Design Form';

    // Load content
    _loadSidebarContent(mode);
  };

  window.closeDesignSidebar = function () {
    const sidebar = document.getElementById('design-sidebar');
    const overlay = document.getElementById('design-sidebar-overlay');
    if (!sidebar) return;

    _closePreviewImageModal();

    sidebar.classList.remove('open');
    setTimeout(() => {
      sidebar.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
    }, 300);
  };

  // Get current item code
  function _getItemCode(container) {
    if (container && container.dataset && container.dataset.itemCode) return container.dataset.itemCode;
    const finalItem = document.getElementById('final-item');
    if (finalItem && finalItem.textContent.trim()) return finalItem.textContent.trim();
    if (typeof PAGE !== 'undefined') {
      return PAGE.templateItemCode || PAGE.itemCode || '';
    }
    return window.templateItemCode || '';
  }

  function _getSelectedAddons() {
    const seen = new Set();
    const addons = [];
    document.querySelectorAll('.addon-checkbox:checked').forEach((cb) => {
      const itemCode = (cb.dataset.itemCode || '').trim();
      if (!itemCode || seen.has(itemCode)) return;
      seen.add(itemCode);
      const card = cb.closest('.addon-card');
      const qtyInput = card ? card.querySelector('.addon-qty-input') : null;
      const nameEl = card ? card.querySelector('.addon-name-text') : null;
      addons.push({
        item_code: itemCode,
        qty: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1,
        name: nameEl ? nameEl.textContent.trim() : itemCode
      });
    });
    return addons;
  }

  function _fetchDesignSidebarData(itemCode, itemRowName) {
    const args = { item_code: itemCode };
    const soInput = document.querySelector('input[name="sales_order"]');
    if (soInput && soInput.value) args.sales_order = soInput.value;
    const quotInput = document.querySelector('input[name="quotation"]');
    if (quotInput && quotInput.value) args.quotation = quotInput.value;
    if (itemRowName) args.item_row_name = itemRowName;
    return new Promise((resolve, reject) => {
      frappe.call({
        method: 'klaviyo_integration.www.product.index.get_design_sidebar_data',
        args: args,
        callback: function (r) {
          if (r && r.message) return resolve(r.message);
          reject(new Error(`No sidebar data for ${itemCode}`));
        },
        error: reject
      });
    });
  }

  // Load sidebar content by mode
  function _loadSidebarContent(mode) {
    const body = document.getElementById('design-sidebar-body') || document;
    if (!body) return;
    body.innerHTML = '<div style="text-align:center;padding:40px;color:#6b7280;"><i class="fa fa-spinner fa-spin"></i> Loading...</div>';

    const itemCode = _getItemCode();
    if (!itemCode) {
      body.innerHTML = '<p style="color:#ef4444;">Please select a product configuration first.</p>';
      return;
    }

    if (mode === 'artwork') {
      _loadArtworkMode(body, itemCode);
    } else if (mode === 'basic_design') {
      _loadBasicDesignMode(body, itemCode);
    } else if (mode === 'custom_quote') {
      _loadCustomQuoteMode(body, itemCode);
    }
  }

  // ARTWORK MODE
  function _loadArtworkMode(body, itemCode, opts) {
    const options = opts || {};
    const itemRowName = body ? body.dataset.itemRowName : null;
    const includeActions = options.includeActions !== false;
    const includeAddons = options.includeAddons !== false;
    const includeBundles = options.includeBundles !== false;
    const formIndexStr = body && body.dataset ? body.dataset.designFormIndex : null;
    const formIndexSuffix = formIndexStr ? '__idx_' + formIndexStr : '';
    return _fetchDesignSidebarData(itemCode, itemRowName)
      .then(async (data) => {
        let html = '';
        const selectedAddons = window._designSidebar.selectedAddons || [];
        const bundleItems = includeBundles
          ? _flattenBundleItems(data.bundle_items || []).filter(
            (bundle) => !_isHiddenInDesignForm(bundle)
          )
          : [];
        window._designSidebar.bundleData = bundleItems;

        let isFirstAccordion = true;
        const mainQty = body && body.dataset ? (body.dataset.qty || 1) : 1;
        const mainRespKey = formIndexStr ? `${itemCode}__${formIndexStr}` : itemCode;
        const savedMainResp = window.SAVED_DESIGN_RESPONSES ? window.SAVED_DESIGN_RESPONSES[mainRespKey] : null;
        const displayMainQty = savedMainResp && savedMainResp.qty ? savedMainResp.qty : mainQty;

        if (itemCode === 'VP') {
          html += _renderDesignItemAccordion({
            title: `${data.item_name || 'Vector Pros'} (x${displayMainQty})`,
            htmlTitle: `<span>${data.item_name || 'Vector Pros'}</span> <span class="neo-badge neo-badge-sm" style="background: #e2e8f0; text-transform: none; letter-spacing: normal;">Qty: ${displayMainQty}</span>`,
            itemCode: itemCode,
            description: '',
            isOpen: isFirstAccordion,
            hideTemplates: true,
            uploadKey: 'main-' + itemCode + formIndexSuffix,
          });
          isFirstAccordion = false;
        } else if (data.product_templates && data.product_templates.length > 0) {
          html += _renderTemplatesAccordion({
            title: `${data.description || data.item_name || itemCode} (x${displayMainQty})`,
            htmlTitle: `<span>${data.description || data.item_name || itemCode}</span> <span class="neo-badge neo-badge-sm" style="background: #e2e8f0; text-transform: none; letter-spacing: normal;">Qty: ${displayMainQty}</span>`,
            itemCode: itemCode,
            templates: data.product_templates,
            isOpen: isFirstAccordion,
            uploadKey: 'main-' + itemCode + formIndexSuffix,
            scope: 'main',
          });
          isFirstAccordion = false;
        }

        if (bundleItems.length) {
          bundleItems.forEach((bundle) => {
            const bundleRespKey = formIndexSuffix ? `${bundle.item_code}${formIndexSuffix.replace('__idx_', '__')}` : bundle.item_code;
            const savedBundleResp = window.SAVED_DESIGN_RESPONSES ? window.SAVED_DESIGN_RESPONSES[bundleRespKey] : null;
            const displayQty = savedBundleResp && savedBundleResp.qty ? savedBundleResp.qty : (bundle.qty || 1);
            if (bundle.item_code === 'VP') {
              html += _renderDesignItemAccordion({
                title: `${bundle.description || bundle.item_code} (x${displayQty})`,
                htmlTitle: `<span>${bundle.description || bundle.item_code}</span> <span class="neo-badge neo-badge-sm" style="background: #e2e8f0; text-transform: none; letter-spacing: normal;">Qty: ${displayQty}</span>`,
                itemCode: bundle.item_code,
                description: '',
                isOpen: isFirstAccordion,
                hideTemplates: true,
                uploadKey: 'bundle-' + bundle.item_code + formIndexSuffix,
              });
              isFirstAccordion = false;
            } else {
              html += _renderTemplatesAccordion({
                title: `${bundle.description || bundle.item_code} (x${displayQty})`,
                htmlTitle: `<span>${bundle.description || bundle.item_code}</span> <span class="neo-badge neo-badge-sm" style="background: #e2e8f0; text-transform: none; letter-spacing: normal;">Qty: ${displayQty}</span>`,
                itemCode: bundle.item_code,
                templates: bundle.downloadable_templates || [],
                isOpen: isFirstAccordion,
                uploadKey: 'bundle-' + bundle.item_code + formIndexSuffix,
                scope: 'bundle',
              });
              isFirstAccordion = false;
            }
          });
        }

        if (includeAddons && selectedAddons.length) {
          const addonResponses = await Promise.all(
            selectedAddons.map((addon) =>
              _fetchDesignSidebarData(addon.item_code)
                .then((addonData) => ({ addon, addonData }))
                .catch(() => null)
            )
          );

          addonResponses
            .forEach(({ addon, addonData }) => {
              if (addon.item_code === 'VP') {
                html += _renderDesignItemAccordion({
                  title: `${addonData.description || addonData.item_name || addon.name || addon.item_code} (x${addon.qty || 1})`,
                  itemCode: addon.item_code,
                  description: '',
                  isOpen: false,
                  hideTemplates: true,
                  uploadKey: 'addon-artwork-' + addon.item_code + formIndexSuffix,
                  badge: 'Addon',
                  accordionClass: 'ds-accordion-addon',
                });
              } else {
                html += _renderTemplatesAccordion({
                  title: `${addonData.description || addonData.item_name || addon.name || addon.item_code} (x${addon.qty || 1})`,
                  itemCode: addon.item_code,
                  templates: addonData.product_templates || [],
                  isOpen: false,
                  uploadKey: 'addon-artwork-' + addon.item_code + formIndexSuffix,
                  scope: 'addon',
                  badge: 'Addon',
                  accordionClass: 'ds-accordion-addon',
                });
              }
            });
        }

        if (!html) {
          html = '<p style="color:#6b7280;">No templates available for this product.</p>';
        }

        if (includeActions) {
          html += `<div class="ds-sidebar-footer" style="position: relative; margin-top: 1rem;"><button class="ds-submit-btn" style="margin-top: 0;" onclick="submitDesignSidebar(this)">Submit Artwork</button></div>`;
        }
        body.innerHTML = html;
        _initAccordions(body);
        _restoreCache('artwork', body);
      })
      .catch(() => {
        body.innerHTML = '<p style="color:#ef4444;">Failed to load data. Please try again.</p>';
      });
  }

  // BASIC DESIGN MODE
  function _loadBasicDesignMode(body, itemCode, opts) {
    const options = opts || {};
    const itemRowName = body ? body.dataset.itemRowName : null;
    const includeActions = options.includeActions !== false;
    const includeCache = options.includeCache !== false;
    const includeInteractions = options.includeInteractions !== false;
    const includeAddons = options.includeAddons !== false;
    const includeBundles = options.includeBundles !== false;
    const formIndexStr = body && body.dataset ? body.dataset.designFormIndex : null;
    const formIndexSuffix = formIndexStr ? '__idx_' + formIndexStr : '';
    return _fetchDesignSidebarData(itemCode, itemRowName)
      .then(async (data) => {
        let html = '';
        const selectedAddons = window._designSidebar.selectedAddons || [];
        window._designSidebar.productData = data || null;
        const includeLogo = options.includeLogo !== false && body.id === 'design-sidebar-body';
        if (includeLogo) {
          html += _buildLogoUploadSection();
        }

        window._designFormSimpleModes = window._designFormSimpleModes || {};
        if (window.SAVED_DESIGN_RESPONSES) {
          for (const key in window.SAVED_DESIGN_RESPONSES) {
            const resp = window.SAVED_DESIGN_RESPONSES[key];
            if (resp) {
              const ic = resp.item_code || key.split('_')[0];
              if (window._designFormSimpleModes[ic] === undefined) {
                window._designFormSimpleModes[ic] = resp.hasOwnProperty('is_simple_mode') ? !!resp.is_simple_mode : true;
              }
            }
          }
        }
        if (window._designFormSimpleModes[itemCode] === undefined) {
            window._designFormSimpleModes[itemCode] = (itemCode === 'VP') ? false : true;
        }
        let isSimple = !!window._designFormSimpleModes[itemCode];
        
        let isLocked = false;
        if (typeof DESIGN_FORM_SUBMITTED !== 'undefined' && DESIGN_FORM_SUBMITTED) {
            isLocked = true;
        }
        if (window.SAVED_DESIGN_RESPONSES) {
            const respKey = formIndexStr ? `${itemCode}__${formIndexStr}` : itemCode;
            const resp = window.SAVED_DESIGN_RESPONSES[respKey];
            if (resp && resp.is_locked) {
                isLocked = true;
            }
        }
        
        if (!isLocked) {
          html += `
            <div class="switch-container">
              <label class="switch-text" for="simple-mode-toggle-${itemCode}">Detailed</label>
              <label class="switch">
                <input type="checkbox" id="simple-mode-toggle-${itemCode}" onchange="if(window.toggleSimpleMode) window.toggleSimpleMode(this, '${itemCode}')" ${!isSimple ? 'checked' : ''}>
                <span class="slider"></span>
              </label>
            </div>
          `;
        }

        if (isSimple) {
          window._designSidebar.bundleData = [];
          html += _renderDesignItemAccordion({
            title: data.description || data.item_name || itemCode,
            itemCode: itemCode,
            description: '',
            templates: [],
            designQuestions: [{ question: 'Enter your instructions' }],
            questions: [],
            designElements: [],
            isOpen: true,
            hideTemplates: true,
            uploadKey: 'main-' + itemCode + formIndexSuffix,
          });
        } else {
          let isFirstAccordion = true;

          if (DESIGN_FORM_MAIN_ONLY) {
          // Show only the main product's own design data, saved under the main item_code.
          window._designSidebar.bundleData = [];
          const mainDesignQuestions = data.design_questions || [];
          const mainGeneralQuestions = data.questions || [];
          const mainDesignElements = data.design_form_elements || [];
          const activeSizeOption = data.active_size_attribute_option || '';
          const activeAttributeOptions = data.active_attribute_options || {};
          const visibleMainDesignElements = _getVisibleDesignElements(
            mainDesignElements,
            activeSizeOption,
            activeAttributeOptions
          );

          if (mainDesignQuestions.length || mainGeneralQuestions.length || visibleMainDesignElements.length) {
            if (visibleMainDesignElements.length) {
              html += _renderDesignElementsPanel({
                title: data.description || data.item_name || itemCode,
                itemCode: itemCode,
                designElements: mainDesignElements,
                uploadKey: 'main-' + itemCode + formIndexSuffix,
                activeSizeOption,
                activeAttributeOptions,
              });
            }
            html += _renderDesignItemAccordion({
              title: 'General questions',
              itemCode: itemCode,
              description: data.item_description || '',
              templates: data.product_templates || [],
              designQuestions: mainDesignQuestions,
              questions: mainGeneralQuestions,
              isOpen: isFirstAccordion,
              hideTemplates: true,
              uploadKey: 'main-' + itemCode + formIndexSuffix,
            });
            isFirstAccordion = false;
          } else {
            html += '<p style="color:#6b7280;font-size:0.85rem;">No design elements or design questions are configured for this product.</p>';
          }
        } else {
          // Original full behavior
          const mainDesignQuestions = data.design_questions || [];
          const mainGeneralQuestions = data.questions || [];
          const mainDesignElements = data.design_form_elements || [];
          const mainActiveSizeOption = data.active_size_attribute_option || '';
          const mainActiveAttributeOptions = data.active_attribute_options || {};
          const visibleMainDesignElements = _getVisibleDesignElements(
            mainDesignElements,
            mainActiveSizeOption,
            mainActiveAttributeOptions
          );

          if (mainDesignQuestions.length || mainGeneralQuestions.length || visibleMainDesignElements.length) {
            const mainQty = body && body.dataset ? (body.dataset.qty || 1) : 1;
            const mainRespKey = formIndexStr ? `${itemCode}__${formIndexStr}` : itemCode;
            const savedMainResp = window.SAVED_DESIGN_RESPONSES ? window.SAVED_DESIGN_RESPONSES[mainRespKey] : null;
            const displayMainQty = savedMainResp && savedMainResp.qty ? savedMainResp.qty : mainQty;
            html += _renderDesignItemAccordion({
              title: `General questions (x${displayMainQty})`,
              htmlTitle: `<span>General questions</span> <span class="neo-badge neo-badge-sm" style="background: #e2e8f0; text-transform: none; letter-spacing: normal;">Qty: ${displayMainQty}</span>`,
              itemCode: itemCode,
              description: data.item_description || '',
              templates: data.product_templates || [],
              designQuestions: mainDesignQuestions,
              questions: mainGeneralQuestions,
              designElements: mainDesignElements,
              activeSizeOption: mainActiveSizeOption,
              activeAttributeOptions: mainActiveAttributeOptions,
              isOpen: isFirstAccordion,
              hideTemplates: true,
              uploadKey: 'main-' + itemCode + formIndexSuffix,
            });
            isFirstAccordion = false;
          }

          const bundleItems = includeBundles
            ? _flattenBundleItems(data.bundle_items || []).filter(
              (bundle) => !_isHiddenInDesignForm(bundle)
            )
            : [];
          window._designSidebar.bundleData = bundleItems;

          if (bundleItems.length) {
            bundleItems.forEach((bundle) => {
              const bundleRespKey = formIndexSuffix ? `${bundle.item_code}${formIndexSuffix.replace('__idx_', '__')}` : bundle.item_code;
              const savedBundleResp = window.SAVED_DESIGN_RESPONSES ? window.SAVED_DESIGN_RESPONSES[bundleRespKey] : null;
              const displayQty = savedBundleResp && savedBundleResp.qty ? savedBundleResp.qty : (bundle.qty || 1);
              const activeSizeOption = bundle.active_size_attribute_option || '';
              const activeAttributeOptions = bundle.active_attribute_options || {};
              // Render the bundle accordion and include design element cards inside the accordion body
              html += _renderDesignItemAccordion({
                title: `${bundle.description || bundle.item_code} (x${displayQty})`,
                htmlTitle: `<span>${bundle.description || bundle.item_code}</span> <span class="neo-badge neo-badge-sm" style="background: #e2e8f0; text-transform: none; letter-spacing: normal;">Qty: ${displayQty}</span>`,
                itemCode: bundle.item_code,
                description: bundle.description || '',
                templates: bundle.downloadable_templates || [],
                designQuestions: bundle.design_questions || [],
                questions: [],
                designElements: bundle.design_form_elements || [],
                activeSizeOption,
                activeAttributeOptions,
                hideGeneralQuestions: true,
                isOpen: isFirstAccordion,
                uploadKey: 'bundle-' + bundle.item_code + formIndexSuffix,
              });
              isFirstAccordion = false;
            });
          }

          if (includeAddons && selectedAddons.length) {
            const addonResponses = await Promise.all(
              selectedAddons.map((addon) =>
                _fetchDesignSidebarData(addon.item_code)
                  .then((addonData) => ({ addon, addonData }))
                  .catch(() => null)
              )
            );

            addonResponses
              .filter((entry) => entry && !_isHiddenInDesignForm(entry.addonData))
              .forEach(({ addon, addonData }) => {
                const activeSizeOption = addonData.active_size_attribute_option || '';
                const activeAttributeOptions = addonData.active_attribute_options || {};
                const visibleDesignElements = _getVisibleDesignElements(
                  addonData.design_form_elements || [],
                  activeSizeOption,
                  activeAttributeOptions
                );
                if (visibleDesignElements.length) {
                  html += _renderDesignElementsPanel({
                    title: `${addonData.description || addonData.item_name || addon.name || addon.item_code} (x${addon.qty || 1})`,
                    itemCode: addon.item_code,
                    designElements: addonData.design_form_elements || [],
                    uploadKey: 'addon-basic-' + addon.item_code + formIndexSuffix,
                    activeSizeOption,
                    activeAttributeOptions,
                  });
                }
                html += _renderDesignItemAccordion({
                  title: `${addonData.description || addonData.item_name || addon.name || addon.item_code} (x${addon.qty || 1})`,
                  itemCode: addon.item_code,
                  description: addonData.item_description || '',
                  templates: addonData.product_templates || [],
                  questions: addonData.questions || [],
                  isOpen: isFirstAccordion,
                  uploadKey: 'addon-basic-' + addon.item_code + formIndexSuffix,
                  badge: 'Addon',
                  accordionClass: 'ds-accordion-addon',
                });
                isFirstAccordion = false;
              });
          }
        }
        }

        if (!html) {
          html = '<p style="color:#6b7280;">No design elements or questions are configured for this product. Our team will contact you if needed.</p>';
        }

        if (includeActions) {
          html += _buildBasicDesignActions();
        }
        body.innerHTML = html;
        _initAccordions(body);
        if (includeCache) {
          _restoreCache('basic_design', body);
        }
        if (includeInteractions) {
          _attachBasicDesignInteractions(body);
        }
      })
      .catch(() => {
        body.innerHTML = '<p style="color:#ef4444;">Failed to load data. Please try again.</p>';
      });
  }

  function _buildCustomQuoteFormHtml(itemCode, opts) {
    const options = opts || {};
    const includeSubmit = options.includeSubmit !== false;
    const user = frappe.session.user;
    const isGuest = !user || user === 'Guest';
    const subjectItem = itemCode || 'this item';

    let html = '<div class="ds-custom-quote-form">';

    html += `<div class="ds-form-group">
      <label class="ds-form-label required">Full Name</label>
      <input type="text" class="ds-form-input" id="ds-cq-name" placeholder="Your name"
        value="${isGuest ? '' : user}" ${isGuest ? '' : ''} />
    </div>`;

    html += `<div class="ds-form-group">
      <label class="ds-form-label required">Email</label>
      <input type="email" class="ds-form-input" id="ds-cq-email" placeholder="your@email.com"
        value="" />
    </div>`;

    html += `<div class="ds-form-group">
      <label class="ds-form-label">Phone</label>
      <input type="text" class="ds-form-input" id="ds-cq-phone" placeholder="Phone number" />
    </div>`;

    html += `<div class="ds-form-group">
      <label class="ds-form-label">Organization</label>
      <input type="text" class="ds-form-input" id="ds-cq-company" placeholder="Company name" />
    </div>`;

    html += `<div class="ds-form-group">
      <label class="ds-form-label required">Subject</label>
      <input type="text" class="ds-form-input" id="ds-cq-subject" value="Custom Quote for ${subjectItem}" />
    </div>`;

    html += `<div class="ds-form-group">
      <label class="ds-form-label required">Message</label>
      <textarea class="ds-form-input ds-form-textarea" id="ds-cq-message" placeholder="Describe your requirements in detail..."></textarea>
    </div>`;

    html += _buildUploadSection('custom-quote');

    if (includeSubmit) {
      html += `<div class="ds-sidebar-footer" style="position: relative; margin-top: 1rem;"><button class="ds-submit-btn primary-btn btn-sm" style="margin-top: 0;" onclick="submitDesignSidebar(this)">Submit Quote Request</button></div>`;
    }
    html += '</div>';

    return html;
  }

  // CUSTOM QUOTE MODE
  function _loadCustomQuoteMode(body, itemCode, opts) {
    const options = opts || {};
    body.innerHTML = _buildCustomQuoteFormHtml(itemCode, options);
    _restoreCache('custom_quote', body);
    body.oninput = () => _saveCache('custom_quote', body);
  }

  // Helpers
  function _escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  function _buildAccordionHeader(title, isOpen, htmlTitle = null) {
    const cleanTitle = extract_quill_text(title || 'Design Details');
    const displayTitle = htmlTitle || _escapeHtml(cleanTitle);
    return `<button type="button" class="ds-accordion-header ${isOpen ? 'active' : ''}" aria-expanded="${isOpen ? 'true' : 'false'}" onclick="toggleDsAccordion(this)">
      <span class="ds-accordion-title" style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">${displayTitle}</span>
      ${_accordionChevronSvg()}
    </button>`;
  }

  function _renderTemplatesAccordion(opts) {
    const {
      title, htmlTitle, itemCode, templates, isOpen, uploadKey, scope, badge, accordionClass
    } = opts;
    const accordionClasses = ['ds-accordion'];
    let html = '';
    if (badge) {
      const wrapperClass = accordionClass || 'ds-accordion-addon';
      html += `<div class="${wrapperClass}"><span class="ds-accordion-badge">${badge}</span>`;
    }
    html += `<div class="${accordionClasses.join(' ')}">`;
    html += _buildAccordionHeader(title, isOpen, htmlTitle);
    html += `<div class="ds-accordion-body ${isOpen ? 'show' : ''}">`;
    if (templates && templates.length) {
      templates.forEach((tpl, i) => {
        let fileUrl = tpl.template || '#';
        for (const p of ['/assets/', '/files/']) {
          const idx = fileUrl.indexOf(p);
          if (idx !== -1) { fileUrl = fileUrl.substring(idx); break; }
        }
        const fileName = 'Download Design Template';
        const downloadName = _escapeHtml(tpl.file_name || fileName);
        html += `<div class="ds-template-row">
          <a href="${fileUrl}" target="_blank" class="ds-template-link" download="${downloadName}" data-filename="${downloadName}" title="Download Template">
            <i data-lucide="download" style="width: 14px; height: 14px; stroke-width: 2.2px;"></i> <span>${fileName}</span>
          </a>
        </div>`;
      });
    } else {
      html += '<p style="color:#6b7280;font-size:0.85rem;margin:0 0 8px;">No downloadable templates found for this item.</p>';
    }
    html += _buildUploadSection(uploadKey);
    html += '</div></div>';
    if (badge) html += '</div>';
    return html;
  }

  function _renderQuestionsAccordion(opts) {
    const {
      title, htmlTitle, itemCode, questions, isOpen, uploadKey, badge, accordionClass
    } = opts;
    const accordionClasses = ['ds-accordion'];
    let html = '';
    if (badge) {
      const wrapperClass = accordionClass || 'ds-accordion-addon';
      html += `<div class="${wrapperClass}"><span class="ds-accordion-badge">${badge}</span>`;
    }
    html += `<div class="${accordionClasses.join(' ')}">`;
    html += _buildAccordionHeader(title, isOpen, htmlTitle);
    html += `<div class="ds-accordion-body ${isOpen ? 'show' : ''}">`;
    if (questions && questions.length) {
      html += _buildQuestionsHtml(questions, itemCode);
    }
    html += _buildUploadSection(uploadKey);
    html += '</div></div>';
    if (badge) html += '</div>';
    return html;
  }

  function _buildQuestionsHtml(questions, itemCode, opts) {
    opts = opts || {};
    const startIndex = Number(opts.startIndex || 0);
    const cacheKeyPrefix = opts.cacheKeyPrefix !== undefined ? opts.cacheKeyPrefix : 'question';
    let html = '';
    questions.forEach((q, qi) => {
      const combinedIdx = startIndex + qi;
      const qTitle = _escapeHtml(q.question || `Question ${combinedIdx + 1}`);
      const qDesc = q.description ? _escapeHtml(q.description) : '';
      const cacheKey = `${cacheKeyPrefix}-${qi}`;
      html += `<div class="ds-question-row">
        <div class="ds-question-title">${qTitle}</div>
        ${qDesc ? '<div class="ds-question-desc">(' + qDesc + ')</div>' : ''}
        <textarea class="ds-question-input" placeholder="Enter answer"
          data-item-code="${itemCode}" data-question-idx="${combinedIdx}" data-cache-key="${cacheKey}"></textarea>
      </div>`;
    });
    return html;
  }

  function _designElementCardsModule() {
    return window.DesignElementCards || null;
  }

  function _formatFileSize(size) {
    const module = _designElementCardsModule();
    if (module && typeof module.formatFileSize === 'function') {
      return module.formatFileSize(size);
    }

    const value = Number(size || 0);
    if (!value) return '0 B';
    if (value < 1024) return `${value} B`;
    if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
    return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  }

  function _renderDesignElementsPanel(opts) {
    const module = _designElementCardsModule();
    if (module && typeof module.renderPanel === 'function') {
      return module.renderPanel(opts, {
        buildUploadSection: _buildUploadSection,
      });
    }
    return '';
  }

  function _getVisibleDesignElements(designElements, activeSizeOption, activeAttributeOptions) {
    const module = _designElementCardsModule();
    if (module && typeof module.getVisibleElements === 'function') {
      return module.getVisibleElements(designElements, {
        activeSizeOption,
        activeAttributeOptions,
      });
    }

    return Array.isArray(designElements) ? designElements : [];
  }

  function _buildBasicDesignActions() {
    const module = _designElementCardsModule();
    if (module && typeof module.buildActions === 'function') {
      return module.buildActions();
    }

    return `
      <div class="ds-basic-actions ds-sidebar-footer" style="position: relative;">
        <button type="button" class="ds-submit-btn" data-action="submit" data-default-label="Submit Design Inputs" onclick="submitDesignSidebar(this)">Save</button>
      </div>
    `;
  }

  function _refreshDesignElementsState(scope) {
    const module = _designElementCardsModule();
    if (module && typeof module.refreshState === 'function') {
      module.refreshState(scope || document, window._designSidebar.pendingFiles);
    }
  }

  function _scheduleBasicDesignAutosave(body) {
    const state = window._designSidebar;
    if (state.autosaveTimer) {
      clearTimeout(state.autosaveTimer);
    }
    state.autosaveTimer = setTimeout(() => {
      _saveCache('basic_design', body);
      _refreshDesignElementsState(body);
      state.autosaveTimer = null;
    }, state.autosaveDelayMs || 1200);
  }

  function _attachBasicDesignInteractions(body) {
    if (!body) return;

    _refreshDesignElementsState(body);

    const module = _designElementCardsModule();
    if (module && typeof module.setupResponsiveColumns === 'function') {
      try { module.setupResponsiveColumns(body); } catch (e) { /* ignore layout setup failures */ }
    }

    if (body.dataset.basicDesignInteractionsBound === '1') {
      return;
    }
    body.dataset.basicDesignInteractionsBound = '1';

    if (module && typeof module.attachInteractions === 'function') {
      module.attachInteractions(body, {
        pendingFiles: window._designSidebar.pendingFiles,
        onAutosave: () => _scheduleBasicDesignAutosave(body),
        onSaveCache: () => _saveCache('basic_design', body),
        onRefreshState: () => _refreshDesignElementsState(body),
        onPreviewImage: (src, altText) => _openPreviewImageModal(src, altText),
      });
      return;
    }

    body.addEventListener('input', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.classList.contains('ds-question-input')) return;

      _scheduleBasicDesignAutosave(body);
      _refreshDesignElementsState(body);
    });

    body.addEventListener('blur', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.classList.contains('ds-question-input')) return;
      _saveCache('basic_design', body);
      _refreshDesignElementsState(body);
    }, true);
  }

  window.toggleDesignElementCard = function (headerBtn) {
    const module = _designElementCardsModule();
    if (module && typeof module.toggleCard === 'function') {
      module.toggleCard(headerBtn, window._designSidebar.pendingFiles);
      return;
    }

    _refreshDesignElementsState(document.getElementById('design-sidebar-body'));
  };

  function _buildUploadSection(key, opts) {
    const options = opts || {};
    const label = options.label || 'Upload Files';
    const buttonText = options.buttonText || '+ Add Attachments';
    const displayType = options.displayType || 'thumb';
    const sectionClass = options.sectionClass || '';
    const helperText = options.helperText || '';
    const allowMultiple = options.allowMultiple !== false;
    const acceptedExtensions = options.acceptedExtensions || '';
    const maxSizeMb = Number(options.maxSizeMb || 0);
    const safeKey = _escapeHtml(key || '');
    return `<div class="ds-upload-section ${sectionClass}">
      <label class="ds-section-title" style="font-weight:600;font-size:0.85rem;display:block;margin-bottom:4px;">${_escapeHtml(label)}</label>
      ${helperText ? `<div class="ds-upload-helper">${_escapeHtml(helperText)}</div>` : ''}
      <button type="button" class="secondary-btn btn-sm" data-upload-key="${safeKey}" data-upload-display="${displayType}" data-upload-multiple="${allowMultiple ? 'true' : 'false'}" data-upload-accepted-ext="${_escapeHtml(acceptedExtensions)}" data-upload-max-mb="${maxSizeMb || ''}" onclick="window.triggerDesignFormUpload ? window.triggerDesignFormUpload(this) : triggerDesignUpload(this)">
        <i class="fa fa-upload"></i> ${_escapeHtml(buttonText)}
      </button>
      <div class="ds-upload-preview ds-upload-preview-${displayType}" data-upload-key="${safeKey}" data-display-type="${displayType}" data-upload-accepted-ext="${_escapeHtml(acceptedExtensions)}" data-upload-max-mb="${maxSizeMb || ''}"></div>
    </div>`;
  }

  function _buildLogoUploadSection() {
    return _buildUploadSection('logo', {
        label: 'Logos',
        buttonText: '+ Add Logo',
        displayType: 'thumb',
        allowMultiple: true,
        sectionClass: 'ds-logo-upload-section',
        helperText: 'Upload your logos (Vector files preferred)',
    });
  }

  function _isHiddenInDesignForm(bundle) {
    return bundle && (bundle.is_hidden_in_design_form === true || bundle.is_hidden_in_design_form === 1);
  }

  function _flattenBundleItems(bundleItems) {
    const flattened = [];
    (bundleItems || []).forEach((bundle) => {
      flattened.push(bundle);
      if (bundle.children && bundle.children.length) {
        flattened.push(..._flattenBundleItems(bundle.children));
      }
    });
    return flattened;
  }

  function _accordionChevronSvg() {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      style="flex-shrink:0; margin-left: 8px;">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>`;
  }

  function _initAccordions(container) {
    if (!container) return;
    container.querySelectorAll('.ds-accordion-body').forEach((panel) => {
      panel.classList.remove('collapsing');
      if (panel.classList.contains('show')) {
        panel.style.height = 'auto';
        panel.style.paddingTop = '';
        panel.style.paddingBottom = '';
      } else {
        panel.style.height = '0px';
        panel.style.paddingTop = '0px';
        panel.style.paddingBottom = '0px';
      }
    });
    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      try {
        window.lucide.createIcons({ root: container });
      } catch (e) { }
    }
  }

  // Accordion toggle
  window.toggleDsAccordion = function (header) {
    const body = header.nextElementSibling;
    if (!body || body.classList.contains('collapsing')) return;

    const isOpen = header.getAttribute('aria-expanded') === 'true';
    header.classList.toggle('active', !isOpen);
    header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    if (isOpen) {
      body.classList.add('collapsing');
      body.style.height = `${body.scrollHeight}px`;
      body.offsetHeight;
      body.classList.remove('show');
      body.style.height = '0px';
      body.style.paddingTop = '0px';
      body.style.paddingBottom = '0px';

      body.addEventListener('transitionend', function onCollapseEnd(e) {
        if (e.target !== body || e.propertyName !== 'height') return;
        body.classList.remove('collapsing');
        body.style.height = '0px';
        body.removeEventListener('transitionend', onCollapseEnd);
      });
      return;
    }

    body.classList.add('show');
    body.style.paddingTop = '';
    body.style.paddingBottom = '';
    body.style.height = '0px';
    body.classList.add('collapsing');
    body.offsetHeight;
    body.style.height = 'auto';
    const targetHeight = body.scrollHeight;
    body.style.height = '0px';
    body.offsetHeight;
    body.style.height = `${targetHeight}px`;

    body.addEventListener('transitionend', function onExpandEnd(e) {
      if (e.target !== body || e.propertyName !== 'height') return;
      body.classList.remove('collapsing');
      body.style.height = 'auto';
      body.removeEventListener('transitionend', onExpandEnd);
    });
  };

  function _isImagePreview(dataurl, name) {
    const value = (dataurl || '').toLowerCase();
    if (value.startsWith('data:image/')) return true;
    return /\.(svg|png|jpe?g|gif|webp)$/i.test(name || value);
  }

  function _ensurePreviewImageModal() {
    let modal = document.getElementById('ds-image-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'ds-image-modal';
    modal.className = 'ds-image-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Image preview');

    modal.innerHTML = `
      <button type="button" class="ds-image-modal-close secondary-btn" aria-label="Close image preview">&times;</button>
      <img class="ds-image-modal-img" alt="Attachment preview" />
    `;

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        _closePreviewImageModal();
      }
    });

    const closeBtn = modal.querySelector('.ds-image-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', _closePreviewImageModal);
    }

    const modalImg = modal.querySelector('.ds-image-modal-img');
    if (modalImg) {
      modalImg.addEventListener('click', (event) => event.stopPropagation());
    }

    document.body.appendChild(modal);
    return modal;
  }

  function _openPreviewImageModal(src, altText) {
    if (!src) return;
    const modal = _ensurePreviewImageModal();
    const modalImg = modal.querySelector('.ds-image-modal-img');
    if (!modalImg) return;

    modalImg.src = src;
    modalImg.alt = altText || 'Attachment preview';
    modal.classList.add('show');
    document.body.classList.add('ds-image-modal-open');
  }

  function _closePreviewImageModal() {
    const modal = document.getElementById('ds-image-modal');
    if (!modal) return;

    const modalImg = modal.querySelector('.ds-image-modal-img');
    if (modalImg) {
      modalImg.removeAttribute('src');
    }
    modal.classList.remove('show');
    document.body.classList.remove('ds-image-modal-open');
  }

  function _findUploadPreviewContainer(scope, key) {
    if (!scope) return null;
    const previews = scope.querySelectorAll ? scope.querySelectorAll('.ds-upload-preview') : [];
    for (const preview of previews) {
      if (preview.dataset.uploadKey === key) {
        return preview;
      }
    }
    return null;
  }

  function _resolveUploadTargetForButton(btn, sidebarBody) {
    const buttonKey = (btn && btn.dataset && btn.dataset.uploadKey) || '';
    const normalizedButtonKey = (buttonKey || '').trim();
    const parentCard = btn && typeof btn.closest === 'function' ? btn.closest('.ds-element-card') : null;

    if (parentCard) {
      const cardKey = (parentCard.dataset && parentCard.dataset.uploadKey) || '';
      const resolvedKey = (cardKey || buttonKey || '').trim();
      const previewContainer = _findUploadPreviewContainer(parentCard, resolvedKey)
        || parentCard.querySelector('.ds-upload-preview')
        || _findUploadPreviewContainer(sidebarBody, resolvedKey);

      return {
        key: resolvedKey,
        previewContainer,
      };
    }

    return {
      key: normalizedButtonKey,
      previewContainer: _findUploadPreviewContainer(btn ? btn.parentElement : null, normalizedButtonKey)
        || _findUploadPreviewContainer(sidebarBody, normalizedButtonKey),
    };
  }

  function _resolveUploadTargetForRestore(mode, body, cachedKey) {
    const key = (cachedKey || '').trim();
    if (!key) {
      return { key: '', previewContainer: null };
    }

    if (mode === 'basic_design' && body) {
      const cards = body.querySelectorAll('.ds-element-card');

      for (const card of cards) {
        if (((card.dataset && card.dataset.uploadKey) || '') !== key) continue;
        const previewContainer = _findUploadPreviewContainer(card, key)
          || card.querySelector('.ds-upload-preview')
          || _findUploadPreviewContainer(body, key);
        return { key, previewContainer };
      }

      const match = key.match(/-element-(\d+)$/);
      if (match) {
        const cacheKey = `element-${match[1]}`;
        for (const card of cards) {
          if (((card.dataset && card.dataset.cacheKey) || '') !== cacheKey) continue;
          const previewContainer = card.querySelector('.ds-upload-preview');
          if (!previewContainer) continue;
          const resolvedKey = ((card.dataset && card.dataset.uploadKey) || previewContainer.dataset.uploadKey || key).trim();
          return { key: resolvedKey, previewContainer };
        }
      }
    }

    return {
      key,
      previewContainer: _findUploadPreviewContainer(body, key),
    };
  }

  function _findPreviewItemNode(previewContainer, fileId) {
    if (!previewContainer) return null;
    const items = previewContainer.querySelectorAll('.preview-attach-item');
    for (const item of items) {
      if (item.dataset.fileId === fileId) {
        return item;
      }
    }
    return null;
  }

  function _setPendingFileStatus(key, fileId, status) {
    const module = _designElementCardsModule();
    if (module && typeof module.setPendingFileStatus === 'function') {
      module.setPendingFileStatus(
        key,
        fileId,
        status,
        window._designSidebar.pendingFiles,
        document.getElementById('design-sidebar-body')
      );
      return;
    }

    const state = window._designSidebar;
    const files = state.pendingFiles.get(key) || [];
    const target = files.find((entry) => entry.id === fileId);
    if (target) target.status = status;

    const body = document.getElementById('design-sidebar-body') || document;
    const previewContainer = _findUploadPreviewContainer(body, key);
    const previewItem = _findPreviewItemNode(previewContainer, fileId);
    const stateNode = previewItem ? previewItem.querySelector('[data-file-state]') : null;
    if (stateNode) {
      stateNode.textContent = status;
    }
  }

  function _buildUploadPreviewItem(key, fileMeta, displayType, mode, body, deletable) {
    const state = window._designSidebar;
    const fileId = fileMeta.id;
    const url = fileMeta.dataurl || fileMeta.uploaded_url || fileMeta.file_url || '';

    const isLocked = document.getElementById('design-form')?.classList.contains('design-form-locked') || (typeof DESIGN_FORM_SUBMITTED !== 'undefined' && DESIGN_FORM_SUBMITTED);
    const isLogoOrAddl = key === 'logo' || key === 'additional_files';
    const isDeletable = deletable !== undefined ? deletable : (isLocked ? isLogoOrAddl : true);

    const wrap = window.renderFilePreview ? window.renderFilePreview({
      url: url,
      name: fileMeta.name,
      key: key,
      fileId: fileId,
      pendingId: fileId,
      size: fileMeta.size,
      status: fileMeta.status || 'Ready',
      displayType: displayType,
      showProgress: true,
      deletable: isDeletable,
      onDelete: () => {
        const files = state.pendingFiles.get(key) || [];
        state.pendingFiles.set(key, files.filter((f) => f.id !== fileId));
        if (wrap) wrap.remove();

        const removedUrl = fileMeta.file_url || (fileMeta.dataurl && !fileMeta.dataurl.startsWith('blob:') ? fileMeta.dataurl : null);
        if (removedUrl) {
          if (!window._removedAttachments) window._removedAttachments = new Set();
          window._removedAttachments.add(removedUrl);
        }

        if (body && mode === 'basic_design') {
          _refreshDesignElementsState(body);
        }
        if (body) _saveCache(mode, body);
      }
    }) : null;

    return wrap;
  }

  function _openDesignFileUploader(opts) {
    const {
      key,
      previewContainer,
      displayType,
      allowMultiple,
      mode,
      body,
      validation,
    } = opts;

    let modal = document.getElementById('ds-upload-method-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'ds-upload-method-modal';
      modal.className = 'confirm-modal-overlay';
      modal.innerHTML = `
        <div class="confirm-modal">
          <button id="ds-modal-close" class="confirm-modal-close">&times;</button>
          <div class="confirm-modal-title">${__('Add Attachment')}</div>
          <div class="confirm-modal-body">
            <div style="display:flex;gap:15px;margin-bottom:20px;">
              <button id="ds-modal-btn-file" class="secondary-btn" style="flex:1;padding:20px 10px;">
                <i class="fa fa-upload fa-2x" style="display:block;margin-bottom:10px;color:inherit;"></i>
                ${__('Upload File')}
              </button>
              <button id="ds-modal-btn-link" class="secondary-btn" style="flex:1;padding:20px 10px;">
                <i class="fa fa-link fa-2x" style="display:block;margin-bottom:10px;color:inherit;"></i>
                ${__('Attach Link')}
              </button>
            </div>
            <div id="ds-modal-link-wrap" style="display:none;">
              <div style="margin-bottom:15px;">
                <label style="display:block;margin-bottom:5px;font-size:0.9rem;font-weight:600;color:#000;text-transform:uppercase;">${__('Link URL')}</label>
                <input type="url" id="ds-modal-input-link" placeholder="https://..." style="width:100%;padding:10px 12px;border:2px solid #000;border-radius:6px;font-size:1rem;box-sizing:border-box;outline:none;" />
              </div>
              <button id="ds-modal-btn-submit-link" class="primary-btn btn-full">${__('Add Link')}</button>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(modal);
    }

    modal.classList.add('show');

    const closeBtn = modal.querySelector('#ds-modal-close');
    const btnFile = modal.querySelector('#ds-modal-btn-file');
    const btnLink = modal.querySelector('#ds-modal-btn-link');
    const linkWrap = modal.querySelector('#ds-modal-link-wrap');
    const inputLink = modal.querySelector('#ds-modal-input-link');
    const btnSubmitLink = modal.querySelector('#ds-modal-btn-submit-link');

    // Reset UI
    btnFile.dataset.active = '0';
    btnLink.dataset.active = '0';
    btnFile.className = 'primary-btn';
    btnLink.className = 'secondary-btn';
    linkWrap.style.display = 'none';
    inputLink.value = '';

    // Remove old listeners
    const newClose = closeBtn.cloneNode(true); closeBtn.replaceWith(newClose);
    const newBtnFile = btnFile.cloneNode(true); btnFile.replaceWith(newBtnFile);
    const newBtnLink = btnLink.cloneNode(true); btnLink.replaceWith(newBtnLink);
    const newBtnSubmit = btnSubmitLink.cloneNode(true); btnSubmitLink.replaceWith(newBtnSubmit);

    function hideModal() {
      modal.classList.remove('show');
    }

    newClose.addEventListener('click', hideModal);
    modal.addEventListener('click', (e) => { if(e.target === modal) hideModal(); });

    newBtnFile.addEventListener('click', () => {
      hideModal();
      _triggerNativeFileInput();
    });

    newBtnLink.addEventListener('click', () => {
      newBtnFile.dataset.active = '0';
      newBtnLink.dataset.active = '1';
      
      newBtnFile.className = 'secondary-btn';
      newBtnLink.className = 'primary-btn';
      
      linkWrap.style.display = 'block';
      inputLink.focus();
    });

    newBtnSubmit.addEventListener('click', () => {
      const url = inputLink.value.trim();
      if (!url) {
        frappe.msgprint(__('Please enter a valid URL.'));
        return;
      }
      hideModal();
      _handleLinkAttachment(url);
    });

    function _triggerNativeFileInput() {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = !!allowMultiple;
      
      input.onchange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;
        
        const state = window._designSidebar;
        if (!state.pendingFiles.has(key)) state.pendingFiles.set(key, []);
        const currentFiles = state.pendingFiles.get(key);
        
        if (!allowMultiple) {
            currentFiles.splice(0, currentFiles.length);
            if (previewContainer) previewContainer.innerHTML = '';
        }

        files.forEach(fileData => {
          const fileMeta = {
            id: `${key}-${Date.now()}-${Math.random()}`,
            file: fileData,
            dataurl: null,
            file_url: null,
            uploaded_url: null,
            name: fileData.name,
            size: fileData.size,
            status: 'Ready',
            parentItemCode: state.activeItemCode || ''
          };

          const allowedExts = validation?.allowedExts;
          if (allowedExts && allowedExts.size) {
            const ext = (fileMeta.name.split('.').pop() || '').toLowerCase();
            if (!allowedExts.has(ext)) {
              frappe.msgprint({
                title: __('Unsupported File Type'),
                message: __('Please upload one of the supported file types: {0}').format(Array.from(allowedExts).join(', ').toUpperCase()),
                indicator: 'orange'
              });
              return;
            }
          }

          const maxSizeBytes = Number(validation?.maxSizeBytes || 0);
          if (maxSizeBytes > 0 && fileMeta.size > maxSizeBytes) {
            frappe.msgprint({
              title: __('File Too Large'),
              message: __('Please upload a file up to {0} MB.').format(Math.round(maxSizeBytes / (1024 * 1024))),
              indicator: 'orange'
            });
            return;
          }

          fileMeta.dataurl = URL.createObjectURL(fileData);
          currentFiles.push(fileMeta);

          let skipAppend = false;
          if (key === 'additional_files' && typeof window._syncAdditionalFilesSection === 'function') skipAppend = true;
          if (key === 'logo' && typeof window._syncLogoSection === 'function') skipAppend = true;

          if (previewContainer && !skipAppend) {
            const item = _buildUploadPreviewItem(key, fileMeta, displayType, mode, body);
            previewContainer.appendChild(item);
          }
        });
        
        if (body && mode === 'basic_design') {
          _refreshDesignElementsState(body);
        }
        
        try {
          if (key === 'additional_files' && typeof window._syncAdditionalFilesSection === 'function') {
            const section = previewContainer ? previewContainer.closest('[data-design-additional-files-section]') : document.querySelector('[data-design-additional-files-section]');
            if (section) window._syncAdditionalFilesSection(section);
          }
          if (key === 'logo' && typeof window._syncLogoSection === 'function') {
            const section = previewContainer ? previewContainer.closest('[data-design-logo-section]') : document.querySelector('[data-design-logo-section]');
            if (section) window._syncLogoSection(section);
          }
        } catch (e) { /* safe-fail */ }
        
        if (body) _saveCache(mode, body);
      };

      input.click();
    }

    function _handleLinkAttachment(url) {
      if (!/^https?:\/\//i.test(url)) {
          url = 'https://' + url;
      }
      const state = window._designSidebar;
      if (!state.pendingFiles.has(key)) state.pendingFiles.set(key, []);
      const currentFiles = state.pendingFiles.get(key);

      if (!allowMultiple) {
        currentFiles.splice(0, currentFiles.length);
        if (previewContainer) previewContainer.innerHTML = '';
      }

      const fileMeta = {
        id: `${key}-${Date.now()}-${Math.random()}`,
        file: null,
        dataurl: url,
        file_url: url,
        uploaded_url: url,
        name: url,
        size: 0,
        status: 'Uploaded',
        parentItemCode: state.activeItemCode || ''
      };

      currentFiles.push(fileMeta);

      let skipAppend = false;
      if (key === 'additional_files' && typeof window._syncAdditionalFilesSection === 'function') skipAppend = true;
      if (key === 'logo' && typeof window._syncLogoSection === 'function') skipAppend = true;

      if (previewContainer && !skipAppend) {
        const item = _buildUploadPreviewItem(key, fileMeta, displayType, mode, body);
        previewContainer.appendChild(item);
      }

      if (body && mode === 'basic_design') {
        _refreshDesignElementsState(body);
      }

      try {
        if (key === 'additional_files' && typeof window._syncAdditionalFilesSection === 'function') {
          const section = previewContainer ? previewContainer.closest('[data-design-additional-files-section]') : document.querySelector('[data-design-additional-files-section]');
          if (section) window._syncAdditionalFilesSection(section);
        }
        if (key === 'logo' && typeof window._syncLogoSection === 'function') {
          const section = previewContainer ? previewContainer.closest('[data-design-logo-section]') : document.querySelector('[data-design-logo-section]');
          if (section) window._syncLogoSection(section);
        }
      } catch (e) { /* safe-fail */ }

      if (body) _saveCache(mode, body);
    }
  }

  // File Upload
  window.triggerDesignUpload = function (btn) {
    const sBody = document.getElementById('design-sidebar-body')
      || (btn && typeof btn.closest === 'function'
        ? btn.closest('.ds-design-form-accordions') || btn.closest('#custom-quote-section')
        : null);
    const uploadTarget = _resolveUploadTargetForButton(btn, sBody);
    const key = uploadTarget.key;
    const previewContainer = uploadTarget.previewContainer;
    if (!key) return;
    const displayType = btn.dataset.uploadDisplay || previewContainer?.dataset.displayType || 'thumb';
    const allowMultiple = btn.dataset.uploadMultiple !== 'false';
    const acceptedExt = (btn.dataset.uploadAcceptedExt || '').trim();
    const maxMb = Number(btn.dataset.uploadMaxMb || 0);
    const mode = window._designSidebar.mode;

    _openDesignFileUploader({
      key,
      previewContainer,
      displayType,
      allowMultiple,
      mode,
      body: sBody,
      validation: {
        allowedExts: acceptedExt ? new Set(acceptedExt.split(',').map((x) => x.trim().toLowerCase()).filter(Boolean)) : null,
        maxSizeBytes: maxMb > 0 ? maxMb * 1024 * 1024 : 0,
      }
    });
  };

  const _uploadOverlay = {
    panel: null,
    list: null,
    header: null,
    collapsed: false,
    autoDismissTimer: null,
    rows: new Map(),
    activeUploads: 0,
  };

  window.addEventListener('beforeunload', (e) => {
    if (_uploadOverlay.activeUploads > 0) {
      e.preventDefault();
      e.returnValue = 'Uploads are in progress. Are you sure you want to leave?';
      return e.returnValue;
    }
  });

  function _ensureOverlayStyles() {
    if (document.getElementById('ds-upload-overlay-styles')) return;
    const style = document.createElement('style');
    style.id = 'ds-upload-overlay-styles';
    style.textContent = `
      #ds-upload-overlay {
        position: absolute;
        bottom: calc(100% + 16px);
        right: 0;
        z-index: 99;
        border: 2px solid #111;
        border-radius: 6px;
        box-shadow: 4px 4px 0 0 #111;
        background: #fff;
        overflow: hidden;
        font-family: inherit;
        width: 50%;
        min-width: 300px;
        max-height: 0;
        opacity: 0;
        transition: max-height 0.32s cubic-bezier(0.4,0,0.2,1),
                    opacity 0.22s ease,
                    width 0.3s cubic-bezier(0.4,0,0.2,1);
        pointer-events: none;
      }
      #ds-upload-overlay.ds-ov-visible {
        max-height: 500px;
        opacity: 1;
        pointer-events: auto;
      }
      #ds-upload-overlay.ds-ov-collapsed {
        /* Compact minimized state UX */
        width: 220px;
        min-width: 220px;
      }
      #ds-upload-overlay.ds-ov-collapsed #ds-upload-overlay-list {
        max-height: 0 !important;
        padding: 0 !important;
        overflow: hidden;
      }
      #ds-upload-overlay-header {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 9px 14px;
        background: #111;
        color: #fff;
        cursor: pointer;
        user-select: none;
        border-bottom: 2.5px solid #111;
        min-height: 44px;
      }
      #ds-upload-overlay-header .ds-ov-icon {
        font-size: 13px;
        font-weight: 900;
        flex-shrink: 0;
        width: 16px;
        text-align: center;
      }
      #ds-upload-overlay-header .ds-ov-title {
        flex: 1;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.09em;
        text-transform: uppercase;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .ds-ov-action-btn {
        background: none;
        border: 1.5px solid rgba(255,255,255,0.3);
        color: #fff;
        cursor: pointer;
        padding: 0 7px;
        border-radius: 0;
        font-size: 15px;
        font-weight: 800;
        line-height: 1;
        min-width: 26px;
        min-height: 26px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: background 0.1s, border-color 0.1s;
        flex-shrink: 0;
      }
      .ds-ov-action-btn:hover {
        background: rgba(255,255,255,0.18);
        border-color: rgba(255,255,255,0.6);
      }
      #ds-upload-overlay-list {
        max-height: 250px;
        overflow-y: auto;
        background: #fff;
        transition: max-height 0.28s ease;
      }
      .ds-ov-row {
        padding: 10px 14px;
        display: flex;
        align-items: flex-start;
        gap: 10px;
        border-bottom: 2px solid #111;
      }
      .ds-ov-row:last-child { border-bottom: none; }
      .ds-ov-row-icon {
        font-size: 15px;
        flex-shrink: 0;
        width: 20px;
        text-align: center;
        margin-top: 1px;
      }
      .ds-ov-row-body { flex: 1; min-width: 0; }
      .ds-ov-row-name {
        font-size: 12px;
        font-weight: 700;
        color: #111;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0.01em;
      }
      .ds-ov-row-status {
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.07em;
        color: #555;
        margin-top: 2px;
      }
      .ds-ov-row-progress {
        height: 6px;
        background: #f3f4f6;
        border: 2px solid #111;
        border-radius: 0;
        margin-top: 7px;
        overflow: hidden;
      }
      .ds-ov-row-progress-fill {
        height: 100%;
        width: 0%;
        background: #ec008c;
        border-radius: 0;
        transition: width 0.1s linear;
      }
      .ds-ov-done-badge, .ds-ov-fail-badge {
        display: inline-block;
        font-size: 10px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.07em;
        padding: 1px 7px;
        margin-top: 6px;
        border: 2px solid #111;
        border-radius: 0;
      }
      .ds-ov-done-badge { background: #111; color: #fff; }
      .ds-ov-fail-badge { background: #ec008c; border-color: #ec008c; color: #fff; }
      #ds-upload-overlay-list::-webkit-scrollbar { width: 4px; }
      #ds-upload-overlay-list::-webkit-scrollbar-track { background: #f3f4f6; }
      #ds-upload-overlay-list::-webkit-scrollbar-thumb { background: #111; border-radius: 0; }
      @media (max-width: 768px) {
        #ds-upload-overlay {
          width: 100%;
          min-width: unset;
          box-shadow: 3px 3px 0 0 #111;
        }
        #ds-upload-overlay.ds-ov-collapsed {
          width: 220px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function _getOrCreateOverlayPanel() {
    _ensureOverlayStyles();
    if (_uploadOverlay.panel) return _uploadOverlay.panel;

    const panel = document.createElement('div');
    panel.id = 'ds-upload-overlay';

    // ── Header ────────────────────────────────────────────────────────────────
    const header = document.createElement('div');
    header.id = 'ds-upload-overlay-header';

    const iconEl = document.createElement('span');
    iconEl.className = 'ds-ov-icon';
    iconEl.textContent = '↑';

    const titleEl = document.createElement('span');
    titleEl.className = 'ds-ov-title';
    titleEl.textContent = 'Uploading files...';

    const collapseBtn = document.createElement('button');
    collapseBtn.type = 'button';
    collapseBtn.className = 'ds-ov-action-btn';
    collapseBtn.title = 'Collapse';
    collapseBtn.textContent = '−';
    collapseBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      _uploadOverlay.collapsed = !_uploadOverlay.collapsed;
      panel.classList.toggle('ds-ov-collapsed', _uploadOverlay.collapsed);
      collapseBtn.title = _uploadOverlay.collapsed ? 'Expand' : 'Collapse';
      collapseBtn.textContent = _uploadOverlay.collapsed ? '+' : '−';
    });

    header.addEventListener('click', () => collapseBtn.click());
    header.appendChild(iconEl);
    header.appendChild(titleEl);
    header.appendChild(collapseBtn);

    // ── File list ─────────────────────────────────────────────────────────────
    const list = document.createElement('div');
    list.id = 'ds-upload-overlay-list';

    panel.appendChild(header);
    panel.appendChild(list);
    // Don't append to body yet — injected before .form-footer on show

    _uploadOverlay.panel = panel;
    _uploadOverlay.list = list;
    _uploadOverlay.header = header;
    _uploadOverlay.titleEl = titleEl;
    _uploadOverlay.iconEl = iconEl;
    _uploadOverlay.collapseBtn = collapseBtn;

    return panel;
  }

  function _showUploadOverlay(fileList) {
    const panel = _getOrCreateOverlayPanel();
    if (_uploadOverlay.autoDismissTimer) {
      clearTimeout(_uploadOverlay.autoDismissTimer);
      _uploadOverlay.autoDismissTimer = null;
    }
    _uploadOverlay.collapsed = false;
    panel.classList.remove('ds-ov-collapsed', 'ds-ov-done');

    // Reset header
    _uploadOverlay.iconEl.textContent = '↑';
    _uploadOverlay.iconEl.style.color = '';
    const count = fileList.length;
    _uploadOverlay.titleEl.textContent = count === 1
      ? 'Uploading 1 file...'
      : `Uploading ${count} file${count !== 1 ? 's' : ''}...`;
    if (_uploadOverlay.collapseBtn) {
      _uploadOverlay.collapseBtn.textContent = '−';
      _uploadOverlay.collapseBtn.title = 'Collapse';
    }

    // Build file rows
    const list = _uploadOverlay.list;
    list.innerHTML = '';
    _uploadOverlay.rows.clear();

    fileList.forEach(({ id, name, size }) => {
      const row = document.createElement('div');
      row.className = 'ds-ov-row';
      row.dataset.fileId = id;

      const iconEl = document.createElement('span');
      iconEl.className = 'ds-ov-row-icon';
      iconEl.textContent = _fileIcon(name);

      const body = document.createElement('div');
      body.className = 'ds-ov-row-body';

      const nameEl = document.createElement('div');
      nameEl.className = 'ds-ov-row-name';
      nameEl.title = name;
      nameEl.textContent = name;

      const sizeStr = size ? _formatFileSize(size) : '';
      const statusEl = document.createElement('div');
      statusEl.className = 'ds-ov-row-status';
      statusEl.textContent = sizeStr ? `${sizeStr} · Queued` : 'Queued';

      const progressWrap = document.createElement('div');
      progressWrap.className = 'ds-ov-row-progress';
      const progressFill = document.createElement('div');
      progressFill.className = 'ds-ov-row-progress-fill';
      progressWrap.appendChild(progressFill);

      body.appendChild(nameEl);
      body.appendChild(statusEl);
      body.appendChild(progressWrap);
      row.appendChild(iconEl);
      row.appendChild(body);
      list.appendChild(row);

      _uploadOverlay.rows.set(id, { row, fill: progressFill, status: statusEl, icon: iconEl, progressWrap, sizeStr });
    });

    // ── Inject inside the form-footer or sidebar-footer (floating above buttons) ──
    const formFooter = document.querySelector('.form-footer');
    const sidebarFooter = document.querySelector('.ds-sidebar-footer');
    const sidebar = document.getElementById('design-sidebar');
    const isSidebarOpen = sidebar && sidebar.classList.contains('open');

    let targetFooter = null;
    if (isSidebarOpen && sidebarFooter && sidebarFooter.offsetParent !== null) {
      targetFooter = sidebarFooter;
    } else if (formFooter && formFooter.offsetParent !== null) {
      targetFooter = formFooter;
    }

    if (targetFooter) {
      if (!targetFooter.contains(panel)) {
        targetFooter.style.position = 'relative'; // Ensure absolute positioning works
        targetFooter.appendChild(panel);
      }
    } else if (!panel.parentNode) {
      // Fallback: append to body with fixed positioning
      panel.style.position = 'fixed';
      panel.style.bottom = '24px';
      panel.style.right = '24px';
      panel.style.width = '340px';
      panel.style.zIndex = '99998';
      document.body.appendChild(panel);
    }

    // Trigger animation
    requestAnimationFrame(() => {
      panel.classList.add('ds-ov-visible');
    });
  }

  function _updateOverlayFile(fileId, percent, statusText, done, failed) {
    const entry = _uploadOverlay.rows.get(fileId);
    if (!entry) return;
    if (!done) {
      if (entry.fill) entry.fill.style.width = `${Math.min(percent, 100)}%`;
      if (entry.status) entry.status.textContent = statusText || `${Math.round(percent)}%`;
    } else {
      // Hide progress bar, show a neo-brutalism status badge instead
      if (entry.progressWrap) entry.progressWrap.style.display = 'none';
      const existing = entry.row.querySelector('.ds-ov-done-badge, .ds-ov-fail-badge');
      if (!existing) {
        const badge = document.createElement('div');
        badge.className = failed ? 'ds-ov-fail-badge' : 'ds-ov-done-badge';
        badge.textContent = failed ? '✗  Failed' : '✓  Done';
        entry.row.querySelector('.ds-ov-row-body').appendChild(badge);
      }
      if (entry.status) entry.status.textContent = failed ? '' : (entry.sizeStr || '');
      if (entry.icon) {
        entry.icon.textContent = failed ? '✗' : '✓';
        entry.icon.style.color = failed ? '#ec008c' : '#111';
      }
    }
  }

  function _updateOverlayHeader(uploadedCount, totalCount, anyFailed) {
    if (!_uploadOverlay.titleEl) return;
    const remaining = totalCount - uploadedCount;
    if (remaining > 0) {
      _uploadOverlay.titleEl.textContent =
        `Uploading ${remaining} of ${totalCount} file${totalCount !== 1 ? 's' : ''}...`;
    } else {
      if (anyFailed) {
        _uploadOverlay.titleEl.textContent = 'Some uploads failed';
        if (_uploadOverlay.iconEl) {
          _uploadOverlay.iconEl.textContent = '!';
          _uploadOverlay.iconEl.style.color = '#ec008c';
        }
      } else {
        _uploadOverlay.titleEl.textContent =
          `${totalCount} upload${totalCount !== 1 ? 's' : ''} complete`;
        if (_uploadOverlay.iconEl) {
          _uploadOverlay.iconEl.textContent = '✓';
          _uploadOverlay.iconEl.style.color = '#ec008c';
        }
      }
    }
  }

  function _hideUploadOverlay(immediate) {
    const panel = _uploadOverlay.panel;
    if (!panel) return;
    if (_uploadOverlay.autoDismissTimer) {
      clearTimeout(_uploadOverlay.autoDismissTimer);
      _uploadOverlay.autoDismissTimer = null;
    }
    const doHide = () => panel.classList.remove('ds-ov-visible');
    if (immediate) {
      doHide();
    } else {
      _uploadOverlay.autoDismissTimer = setTimeout(doHide, 3500);
    }
  }

  function _fileIcon(name) {
    const ext = (name || '').split('.').pop().toLowerCase();
    const imageExts = new Set(['png','jpg','jpeg','gif','webp','svg','bmp','tif','tiff']);
    const docExts = new Set(['pdf','doc','docx','txt','rtf']);
    const aiExts = new Set(['ai','eps','psd','psb']);
    if (imageExts.has(ext)) return '🖼';
    if (aiExts.has(ext)) return '🎨';
    if (docExts.has(ext)) return '📄';
    return '📎';
  }

  // Upload pending files, return map of key -> [urls]
  async function _uploadPendingFiles() {
    const state = window._designSidebar;
    const result = {};
    const is_private = 1;

    // Collect all files that actually need uploading for the overlay
    const filesToUpload = [];
    for (const [key, files] of state.pendingFiles.entries()) {
      for (const fileObj of files) {
        if (!fileObj.file_url && !(fileObj.status === 'Uploaded' && fileObj.uploaded_url) && fileObj.file) {
          filesToUpload.push({ id: fileObj.id, name: fileObj.name, size: fileObj.size });
        }
      }
    }

    // Show overlay if there are files to upload
    if (filesToUpload.length > 0) {
      _showUploadOverlay(filesToUpload);
      _uploadOverlay.activeUploads += filesToUpload.length;
    }

    let uploadedCount = 0;
    let anyFailed = false;

    for (const [key, files] of state.pendingFiles.entries()) {
      result[key] = [];
      for (const fileObj of files) {
        if (fileObj.file_url) {
          result[key].push(fileObj.file_url);
          _setPendingFileStatus(key, fileObj.id, 'Uploaded');
          continue;
        }
        if (fileObj.status === 'Uploaded' && fileObj.uploaded_url) {
          result[key].push(fileObj.uploaded_url);
          continue;
        }
        _setPendingFileStatus(key, fileObj.id, 'Uploading');

        // Update overlay row to uploading state
        _updateOverlayFile(fileObj.id, 0, 'Uploading...');

        const body = document.getElementById('design-sidebar-body') || document;
        const previewContainer = _findUploadPreviewContainer(body, key);
        const previewItem = _findPreviewItemNode(previewContainer, fileObj.id);
        const progressWrap = previewItem ? previewItem.querySelector('.ds-preview-progress') : null;
        const progressFill = previewItem ? previewItem.querySelector('.ds-preview-progress-fill') : null;
        
        if (progressWrap) progressWrap.style.display = 'block';
        if (progressFill) progressFill.style.width = '0%';

        try {
          const uploaded_url = await _uploadFileChunked(fileObj.file, is_private, (percent) => {
            if (progressFill) progressFill.style.width = `${percent}%`;
            // Update overlay progress
            const sizeStr = fileObj.size ? _formatFileSize(fileObj.size) : '';
            _updateOverlayFile(fileObj.id, percent, sizeStr ? `${sizeStr} · ${Math.round(percent)}%` : `${Math.round(percent)}%`);
            _updateOverlayHeader(uploadedCount, filesToUpload.length, anyFailed);
          });
          
          if (uploaded_url) {
            result[key].push(uploaded_url);
            fileObj.uploaded_url = uploaded_url;
            _setPendingFileStatus(key, fileObj.id, 'Uploaded');
            uploadedCount++;
            _updateOverlayFile(fileObj.id, 100, 'Done', true, false);
          } else {
            _setPendingFileStatus(key, fileObj.id, 'Failed');
            anyFailed = true;
            uploadedCount++;
            _updateOverlayFile(fileObj.id, 100, 'Failed', true, true);
          }
        } catch (e) {
          _setPendingFileStatus(key, fileObj.id, 'Failed');
          anyFailed = true;
          uploadedCount++;
          _updateOverlayFile(fileObj.id, 100, 'Failed', true, true);
          console.error('Upload failed for', fileObj.name, e);
        }
        _updateOverlayHeader(uploadedCount, filesToUpload.length, anyFailed);
      }
    }

    // All done — auto-hide overlay after delay
    if (filesToUpload.length > 0) {
      _uploadOverlay.activeUploads = Math.max(0, _uploadOverlay.activeUploads - filesToUpload.length);
      _updateOverlayHeader(uploadedCount, filesToUpload.length, anyFailed);
      _hideUploadOverlay(false);
    }

    return result;
  }

  async function _uploadFileChunked(file, is_private, progressCallback) {
      const chunkSize = 5 * 1024 * 1024; // 5MB chunks
      const totalChunks = Math.ceil(file.size / chunkSize) || 1;
      const upload_id = frappe.utils.get_random(10);
      
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          const start = chunkIndex * chunkSize;
          const end = Math.min(start + chunkSize, file.size);
          const chunk = file.slice(start, end);
          const isLast = chunkIndex === totalChunks - 1;
          
          const result = await new Promise((resolve, reject) => {
              const xhr = new XMLHttpRequest();

              xhr.upload.onprogress = function(e) {
                  if (file.size > 0) {
                      const chunkLoaded = e.loaded || 0;
                      const totalLoaded = (chunkIndex * chunkSize) + chunkLoaded;
                      const percentComplete = Math.min((totalLoaded / file.size) * 100, 100);
                      if (progressCallback) progressCallback(percentComplete);
                  } else if (progressCallback) {
                      progressCallback(100);
                  }
              };

              xhr.open('POST', '/api/method/klaviyo_integration.apis.design_job.upload_file_chunk', true);
              xhr.setRequestHeader('Accept', 'application/json');
              xhr.setRequestHeader('X-Frappe-CSRF-Token', frappe.csrf_token);
              
              xhr.onload = function() {
                  if (xhr.status === 200) {
                      try {
                          const r = JSON.parse(xhr.responseText);
                          if (r.exc || (r._server_messages && r._server_messages.includes("Error"))) {
                              reject(new Error(r.exc || 'Upload failed'));
                          } else if (isLast && r.message && r.message.file_url) {
                              resolve(r.message.file_url);
                          } else {
                              resolve(r.message);
                          }
                      } catch (e) {
                          reject(new Error('Invalid JSON response'));
                      }
                  } else {
                      reject(new Error('Upload failed with status ' + xhr.status));
                  }
              };
              
              xhr.onerror = function() {
                  reject(new Error('Upload failed (Network error)'));
              };
              
              const formData = new FormData();
              formData.append('file_name', file.name);
              formData.append('file_size', file.size);
              formData.append('chunk_index', chunkIndex);
              formData.append('total_chunks', totalChunks);
              formData.append('is_last', isLast ? 1 : 0);
              formData.append('is_private', is_private);
              formData.append('upload_id', upload_id);
              formData.append('chunk', chunk, file.name);
              
              xhr.send(formData);
          });
          
          if (isLast) {
              return result;
          }
      }
      return null;
  }

  // Submit
  window.submitDesignSidebar = async function (triggerBtn) {
    const state = window._designSidebar;
    const mode = state.mode;
    const btn = triggerBtn && triggerBtn.classList
      ? triggerBtn
      : document.querySelector('.ds-submit-btn[data-action="submit"]') || document.querySelector('.ds-submit-btn');
    if (!btn) return;

    const container = btn.closest('.cart-inline-form-container') || document.getElementById('design-sidebar-body') || document;

    const defaultLabel = btn.dataset.defaultLabel || btn.textContent || 'Submit';
    btn.dataset.defaultLabel = defaultLabel;

    btn.disabled = true;
    btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Saving...';

    try {
      const uploadedUrls = await _uploadPendingFiles();

      if (mode === 'custom_quote') {
        await _submitCustomQuote(uploadedUrls, container);
      } else {
        await _submitDesignForm(mode, uploadedUrls, container);
      }
    } catch (e) {
      console.error('Submission error:', e);
      frappe.msgprint({ title: __('Error'), message: __('Failed to submit. Please try again.'), indicator: 'red' });
      btn.disabled = false;
      btn.textContent = btn.dataset.defaultLabel || (mode === 'custom_quote' ? 'Submit Quote Request' : (mode === 'artwork' ? 'Submit Artwork' : 'Submit Design Inputs'));
    }
  };

  // Submit Design Form (artwork / basic_design)
  async function _submitDesignForm(mode, uploadedUrls, container) {
    const itemCode = _getItemCode(container);
    const body = container || document.getElementById('design-sidebar-body');
    const addonCodes = new Set((window._designSidebar.selectedAddons || []).map(a => a.item_code));
    const bundleItems = Array.isArray(window._designSidebar.bundleData) ? window._designSidebar.bundleData : [];
    const bundleCodes = [...new Set(bundleItems.map((item) => item.item_code).filter(Boolean))];
    const logoUrls = window._getDesignLogoUrls ? window._getDesignLogoUrls(null, uploadedUrls) : _getDesignLogoUrls(null, uploadedUrls);
    if (mode === 'basic_design' && (!logoUrls || logoUrls.length === 0)) {
      const confirmed = await showCustomConfirm(
        'Missing Logo',
        'You have not added any logos. Are you sure you want to continue without a logo?',
        [
          { text: 'Cancel', value: false, primary: false },
          { text: 'Continue', value: true, primary: true }
        ]
      );
      if (!confirmed) {
        const submitBtn = document.querySelector('.ds-submit-btn[data-action="submit"]') || document.querySelector('.ds-submit-btn');
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = submitBtn.dataset.defaultLabel || 'Submit'; }
        return;
      }
    }
    const logoUrl = logoUrls.length ? logoUrls[0] : '';
    const additionalFiles = window._getDesignAdditionalFileUrls ? window._getDesignAdditionalFileUrls(null, uploadedUrls) : _getDesignAdditionalFileUrls(null, uploadedUrls);

    // Build items_data
    const items_data = [];

    const itemGroups = {};
    const addGroupValue = (ic, question, answer) => {
      if (!ic || !question) return;
      if (!itemGroups[ic]) itemGroups[ic] = { questions: [], answers: [] };
      itemGroups[ic].questions.push(question);
      itemGroups[ic].answers.push((answer || '').trim());
    };

    body.querySelectorAll('.ds-question-input:not(.ds-element-note-input)').forEach((ta) => {
      const ic = ta.dataset.itemCode;
      const row = ta.closest('.ds-question-row');
      const qTitle = row ? (row.querySelector('.ds-question-title')?.textContent || '').trim() : '';
      addGroupValue(ic, qTitle, ta.value);
    });

    body.querySelectorAll('.ds-element-note-input').forEach((ta) => {
      const ic = ta.dataset.itemCode;
      const elementName = (ta.dataset.elementName || 'Design Element').trim();
      addGroupValue(ic, `Design Element: ${elementName}`, ta.value);
    });

    if (mode === 'artwork') {
      const bundleData = window._designSidebar.bundleData || [];

      items_data.push({
        item_code: itemCode,
        item_name: itemCode,
        item_group: '',
        questions: itemGroups[itemCode] ? itemGroups[itemCode].questions : [],
        answers: itemGroups[itemCode] ? itemGroups[itemCode].answers : [],
        uploaded_images: _collectUploads(uploadedUrls, 'main-' + itemCode),
        design_mode: 'artwork',
        qty: window._designSidebar.bundleData ? window._designSidebar.bundleData.find(b => b.item_code === itemCode)?.qty || 1 : 1,
        design_form_index: window._designSidebar.designFormIndex,
        is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[itemCode] ? 1 : 0,
        simple_instructions: (window._designFormSimpleModes && window._designFormSimpleModes[itemCode] && itemGroups[itemCode] && itemGroups[itemCode].answers.length) ? itemGroups[itemCode].answers[0] : ''
      });

      bundleData.forEach((bundle) => {
        const ic = bundle.item_code;
        const templates = bundle.downloadable_templates || [];
        const uploadKey = 'bundle-' + ic;
        items_data.push({
          item_code: ic,
          parent_item_code: itemCode,
          item_name: bundle.description || ic,
          item_group: bundle.item_group || '',
          questions: itemGroups[ic] ? itemGroups[ic].questions : [],
          answers: itemGroups[ic] ? itemGroups[ic].answers : [],
          uploaded_images: _collectUploads(uploadedUrls, uploadKey),
          design_mode: 'artwork',
          qty: bundle.qty || 1,
          design_form_index: window._designSidebar.designFormIndex,
          is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[ic] ? 1 : 0,
          simple_instructions: (window._designFormSimpleModes && window._designFormSimpleModes[ic] && itemGroups[ic] && itemGroups[ic].answers.length) ? itemGroups[ic].answers[0] : ''
        });
      });

      // Addon items
      addonCodes.forEach((addonCode) => {
        if (items_data.some(item => item.item_code === addonCode)) return;
        const addonMeta = selectedAddons.find(a => a.item_code === addonCode);
        items_data.push({
          item_code: addonCode,
          parent_item_code: '',
          item_name: addonMeta?.name || addonCode,
          item_group: addonMeta?.item_group || '',
          questions: itemGroups[addonCode] ? itemGroups[addonCode].questions : [],
          answers: itemGroups[addonCode] ? itemGroups[addonCode].answers : [],
          uploaded_images: _collectUploads(uploadedUrls, 'addon-artwork-' + addonCode),
          design_mode: 'artwork',
          qty: addonMeta?.qty || 1,
          design_form_index: window._designSidebar.designFormIndex,
          is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[addonCode] ? 1 : 0,
          simple_instructions: (window._designFormSimpleModes && window._designFormSimpleModes[addonCode] && itemGroups[addonCode] && itemGroups[addonCode].answers.length) ? itemGroups[addonCode].answers[0] : ''
        });
      });
    } else {
      // basic_design — collect questions/answers
      // Main item
      if (itemGroups[itemCode]) {
        items_data.push({
          item_code: itemCode, item_name: itemCode, item_group: '',
          questions: itemGroups[itemCode].questions,
          answers: itemGroups[itemCode].answers,
          uploaded_images: _collectUploads(uploadedUrls, 'main-' + itemCode),
          design_mode: 'basic_design',
          qty: window._designSidebar.bundleData ? window._designSidebar.bundleData.find(b => b.item_code === itemCode)?.qty || 1 : 1,
          design_form_index: window._designSidebar.designFormIndex,
          is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[itemCode] ? 1 : 0,
          simple_instructions: (window._designFormSimpleModes && window._designFormSimpleModes[itemCode] && itemGroups[itemCode].answers.length) ? itemGroups[itemCode].answers[0] : ''
        });
      }

      if (!DESIGN_FORM_MAIN_ONLY) {
        // Bundle items
        for (const [ic, data] of Object.entries(itemGroups)) {
          if (ic === itemCode) continue;
          const uploadKey = addonCodes.has(ic) ? ('addon-basic-' + ic) : ('bundle-' + ic);
          const bundleMeta = bundleItems.find(b => b.item_code === ic);
          const addonMeta = addonCodes.has(ic) ? selectedAddons.find(a => a.item_code === ic) : null;
          
          items_data.push({
            item_code: ic,
            parent_item_code: addonCodes.has(ic) ? '' : itemCode,
            item_name: bundleMeta?.item_name || bundleMeta?.description || addonMeta?.name || ic,
            item_group: bundleMeta?.item_group || addonMeta?.item_group || '',
            questions: data.questions, answers: data.answers,
            uploaded_images: _collectUploads(uploadedUrls, uploadKey),
            design_mode: 'basic_design',
            qty: bundleMeta?.qty || addonMeta?.qty || 1,
            design_form_index: window._designSidebar.designFormIndex,
            is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[ic] ? 1 : 0,
            simple_instructions: (window._designFormSimpleModes && window._designFormSimpleModes[ic] && data.answers.length) ? data.answers[0] : ''
          });
        }

        addonCodes.forEach((addonCode) => {
          if (items_data.some(item => item.item_code === addonCode)) return;
          const addonMeta = selectedAddons.find(a => a.item_code === addonCode);
          items_data.push({
            item_code: addonCode,
            parent_item_code: '',
            item_name: addonMeta?.name || addonCode,
            item_group: addonMeta?.item_group || '',
            questions: [], answers: [],
            uploaded_images: _collectUploads(uploadedUrls, 'addon-basic-' + addonCode),
            design_mode: 'basic_design',
            qty: addonMeta?.qty || 1,
            design_form_index: window._designSidebar.designFormIndex,
            is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[addonCode] ? 1 : 0,
            simple_instructions: ''
          });
        });

        bundleCodes.forEach((bundleCode) => {
          if (items_data.some(item => item.item_code === bundleCode)) return;
          const bundleMeta = bundleItems.find(b => b.item_code === bundleCode);
          items_data.push({
            item_code: bundleCode,
            parent_item_code: itemCode,
            item_name: bundleMeta?.item_name || bundleMeta?.description || bundleCode,
            item_group: bundleMeta?.item_group || '',
            questions: [], answers: [],
            uploaded_images: _collectUploads(uploadedUrls, 'bundle-' + bundleCode),
            design_mode: 'basic_design',
            qty: bundleMeta?.qty || 1,
            design_form_index: window._designSidebar.designFormIndex,
            is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[bundleCode] ? 1 : 0,
            simple_instructions: ''
          });
        });
      }
    }

    if (!items_data.length) {
      // Still submit with at least main item and uploads
      items_data.push({
        item_code: itemCode, item_name: itemCode, item_group: '',
        questions: [], answers: [],
        uploaded_images: _collectUploads(uploadedUrls, Object.keys(uploadedUrls)[0] || ''),
        design_mode: mode,
        qty: 1,
        design_form_index: window._designSidebar.designFormIndex,
        is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[itemCode] ? 1 : 0,
        simple_instructions: ''
      });
    }

    let cachedResponseName = null;
    try {
      const cached = JSON.parse(localStorage.getItem(_cacheKey(mode)) || '{}');
      cachedResponseName = cached.response_name || null;
    } catch (e) {
      cachedResponseName = null;
    }

    const res = await frappe.call({
      method: 'klaviyo_integration.www.design_form.index.save_design_sidebar_response',
      args: {
        item_code: itemCode,
        design_mode: mode,
        items_data: JSON.stringify(items_data),
        design_form_url: window.location.href,
        response_name: cachedResponseName,
        logo_url: logoUrl,
        logo_urls: JSON.stringify(logoUrls),
        additional_files: JSON.stringify(additionalFiles)
      }
    });

    if (res && res.message && res.message.status === 'success') {
      if (res.message.name) _setCacheResponseName(mode, res.message.name);
      _markButtonSubmitted(mode);
      _markCacheSubmitted(mode);
      _enterEditMode(mode);
      try {
        if (typeof window.clearDesignFormUploadCache === 'function') {
          window.clearDesignFormUploadCache();
        }
        if (window._designSidebar && window._designSidebar.pendingFiles) {
          window._designSidebar.pendingFiles = new Map();
        }
      } catch (e) {}
      frappe.msgprint({ title: __('Success'), message: res.message.message || __('Submitted successfully!'), indicator: 'green' });
      setTimeout(() => {
        if (container && container.classList && container.classList.contains('cart-inline-form-container')) {
           $(container).closest('.sidebar-design-accordion-body').find('.sidebar-design-empty').show();
           $(container).parent().hide();
        } else {
           closeDesignSidebar();
        }
      }, 1500);
    } else {
      throw new Error('Submission failed');
    }
  }

  // Submit Custom Quote (Lead)
  async function _submitCustomQuote(uploadedUrls, container) {
    const root = container || document;
    const name = root.querySelector('#ds-cq-name')?.value?.trim();
    const email = root.querySelector('#ds-cq-email')?.value?.trim();
    const phone = root.querySelector('#ds-cq-phone')?.value?.trim();
    const company = root.querySelector('#ds-cq-company')?.value?.trim();
    const subject = root.querySelector('#ds-cq-subject')?.value?.trim();
    const message = root.querySelector('#ds-cq-message')?.value?.trim();

    if (!name || !email || !subject || !message) {
      frappe.msgprint({ title: __('Missing Fields'), message: __('Please fill in all required fields.'), indicator: 'orange' });
      const btn = document.querySelector('.ds-submit-btn');
      if (btn) { btn.disabled = false; btn.textContent = 'Submit Quote Request'; }
      return;
    }

    const logoUrl = _getLogoUploadUrl(uploadedUrls);
    const logoUrls = _getLogoUploadUrls(uploadedUrls);  // NEW
    const fileUrls = _collectUploads(uploadedUrls, 'custom-quote');
    if (logoUrl) fileUrls.push(logoUrl);

    const res = await frappe.call({
      method: 'klaviyo_integration.www.product.index.create_custom_quote_lead',
      args: {
        lead_name: name,
        email: email,
        phone: phone,
        company: company,
        subject: subject,
        message: message,
        item_code: _getItemCode(),
        file_urls: JSON.stringify(fileUrls)
      }
    });

    if (res && res.message && res.message.status === 'success') {
      _markButtonSubmitted(window._designSidebar.mode);
      _markCacheSubmitted('custom_quote');
      _enterEditMode('custom_quote');
      try {
        if (typeof window.clearDesignFormUploadCache === 'function') {
          window.clearDesignFormUploadCache();
        }
        if (window._designSidebar && window._designSidebar.pendingFiles) {
          window._designSidebar.pendingFiles = new Map();
        }
      } catch (e) {}
      frappe.msgprint({ title: __('Success'), message: res.message.message || __('Quote request submitted!'), indicator: 'green' });
      setTimeout(() => {
        if (container && container.classList && container.classList.contains('cart-inline-form-container')) {
           $(container).closest('.sidebar-design-accordion-body').find('.sidebar-design-empty').show();
           $(container).parent().hide();
        } else {
           closeDesignSidebar();
        }
      }, 1500);
    } else {
      throw new Error('Custom quote submission failed');
    }
  }

  // Mark a choice button as submitted with a check badge
  function _markButtonSubmitted(mode) {
    const btn = document.querySelector(`.design-choice-btn[data-mode="${mode}"]`);
    if (!btn) return;
    // Remove existing badge on this button only to avoid duplicates
    const existingBadge = btn.querySelector('.design-choice-submitted-badge');
    if (existingBadge) existingBadge.remove();
    btn.classList.add('submitted');
    const badge = document.createElement('span');
    badge.className = 'design-choice-submitted-badge';
    badge.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    btn.appendChild(badge);
  }

  function _unmarkButtonSubmitted(mode) {
    const btn = document.querySelector(`.design-choice-btn[data-mode="${mode}"]`);
    if (!btn) return;
    btn.classList.remove('submitted');
    const badge = btn.querySelector('.design-choice-submitted-badge');
    if (badge) badge.remove();
  }

  function _cacheKey(mode, itemCode) {
    return `ds_form_cache_${mode}_${itemCode || _getItemCode()}`;
  }

  function _fileCacheKey(mode, itemCode) {
    return `ds_files_${mode}_${itemCode || _getItemCode()}`;
  }

  function _setCacheResponseName(mode, responseName) {
    if (!responseName) return;
    try {
      const raw = localStorage.getItem(_cacheKey(mode));
      const cache = raw ? JSON.parse(raw) : { fields: {} };
      cache.response_name = responseName;
      localStorage.setItem(_cacheKey(mode), JSON.stringify(cache));
    } catch (e) { }
  }

  function _dataUrlToFile(dataurl, filename) {
    try {
      const arr = dataurl.split(',');
      const mime = (arr[0].match(/:(.*?);/) || [])[1] || 'application/octet-stream';
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) u8arr[n] = bstr.charCodeAt(n);
      return new File([u8arr], filename, { type: mime });
    } catch (e) {
      return new File([], filename);
    }
  }

  function _saveCache(mode, body) {
    try {
      const cacheItemCode = body && body.dataset ? body.dataset.cacheItemCode : null;
      const formIndexStr = body && body.dataset ? body.dataset.designFormIndex : null;
      const formIndexSuffix = formIndexStr ? '__idx_' + formIndexStr : '';
      const cacheKey = _cacheKey(mode, cacheItemCode || undefined) + formIndexSuffix;
      const fileCacheKey = _fileCacheKey(mode, cacheItemCode || undefined) + formIndexSuffix;
      const existing = localStorage.getItem(cacheKey);
      const parsed = existing ? JSON.parse(existing) : {};
      const cache = {
        fields: {},
        submitted: parsed.submitted || false,
        response_name: parsed.response_name || null
      };

      if (mode === 'basic_design') {
        body.querySelectorAll('.ds-question-input:not(.ds-element-note-input)').forEach(ta => {
          const ic = ta.dataset.itemCode;
          const qi = ta.dataset.cacheKey || ta.dataset.questionIdx;
          if (!ic || !qi) return;
          if (!cache.fields[ic]) cache.fields[ic] = {};
          cache.fields[ic][qi] = ta.value;
        });
        // Also save design element card notes
        const elements = {};
        body.querySelectorAll('.ds-element-note-input').forEach(ta => {
          const ck = ta.dataset.cacheKey;
          if (!ck) return;
          elements[ck] = ta.value;
        });
        if (Object.keys(elements).length) cache.elements = elements;
      } else if (mode === 'custom_quote') {
        ['ds-cq-name', 'ds-cq-email', 'ds-cq-phone', 'ds-cq-company', 'ds-cq-subject', 'ds-cq-message'].forEach(id => {
          const el = document.getElementById(id);
          if (el) cache.fields[id] = el.value;
        });
      }

      localStorage.setItem(cacheKey, JSON.stringify(cache));

      // Store file attachments in sessionStorage (avoids localStorage quota from base64 data URLs)
      const fileCache = {};
      window._designSidebar.pendingFiles.forEach((files, key) => {
        if (!files.length) return;
        fileCache[key] = files.map(f => ({
          id: f.id, dataurl: f.dataurl, name: f.name,
          size: f.size || 0, status: f.status || 'Ready',
          parentItemCode: f.parentItemCode || ''
        }));
      });
      if (Object.keys(fileCache).length) {
        sessionStorage.setItem(fileCacheKey, JSON.stringify(fileCache));
      } else {
        sessionStorage.removeItem(fileCacheKey);
      }
    } catch (e) { /* storage full or unavailable */ }
  }

  function _restoreCache(mode, body) {
    try {
      const cacheItemCode = body && body.dataset ? body.dataset.cacheItemCode : null;
      const formIndexStr = body && body.dataset ? body.dataset.designFormIndex : null;
      const formIndexSuffix = formIndexStr ? '__idx_' + formIndexStr : '';
      const cacheKey = _cacheKey(mode, cacheItemCode || undefined) + formIndexSuffix;
      const fileCacheKey = _fileCacheKey(mode, cacheItemCode || undefined) + formIndexSuffix;

      // Restore text fields from backend first
      if (mode === 'basic_design' || mode === 'artwork') {
        const backendFormIndex = (body && body.dataset && body.dataset.designFormIndex) || (window._designSidebar && window._designSidebar.designFormIndex !== undefined ? String(window._designSidebar.designFormIndex) : '0');
        
        body.querySelectorAll('.ds-question-input:not(.ds-element-note-input)').forEach(ta => {
           const ic = ta.dataset.itemCode;
           if (!ic) return;
           
           let resp = window.SAVED_DESIGN_RESPONSES && (window.SAVED_DESIGN_RESPONSES[`${ic}__${backendFormIndex}`] || window.SAVED_DESIGN_RESPONSES[`${ic}__0`] || window.SAVED_DESIGN_RESPONSES[ic]);
           if (!resp && window.SAVED_DESIGN_RESPONSES) {
               const fallbackKey = Object.keys(window.SAVED_DESIGN_RESPONSES).find(k => k.startsWith(`${ic}__`));
               if (fallbackKey) resp = window.SAVED_DESIGN_RESPONSES[fallbackKey];
           }
           if (resp && Array.isArray(resp.answers) && Array.isArray(resp.questions)) {
              const row = ta.closest('.ds-question-row');
              const qTitle = row ? (row.querySelector('.ds-question-title')?.textContent || '').trim() : '';
              if (qTitle) {
                  const qIdx = resp.questions.findIndex(q => (q || '').trim() === qTitle);
                  if (qIdx !== -1 && resp.answers[qIdx] !== undefined) {
                      ta.value = resp.answers[qIdx];
                  }
              }
           }
        });
        
        body.querySelectorAll('.ds-element-note-input').forEach(ta => {
           const ic = ta.dataset.itemCode;
           if (!ic) return;
           let resp = window.SAVED_DESIGN_RESPONSES && (window.SAVED_DESIGN_RESPONSES[`${ic}__${backendFormIndex}`] || window.SAVED_DESIGN_RESPONSES[`${ic}__0`] || window.SAVED_DESIGN_RESPONSES[ic]);
           if (!resp && window.SAVED_DESIGN_RESPONSES) {
               const fallbackKey = Object.keys(window.SAVED_DESIGN_RESPONSES).find(k => k.startsWith(`${ic}__`));
               if (fallbackKey) resp = window.SAVED_DESIGN_RESPONSES[fallbackKey];
           }
           if (resp && Array.isArray(resp.answers) && Array.isArray(resp.questions)) {
              const elementName = (ta.dataset.elementName || 'Design Element').trim();
              const searchTitle = `Design Element: ${elementName}`;
              const qIdx = resp.questions.findIndex(q => (q || '').trim() === searchTitle);
              if (qIdx !== -1 && resp.answers[qIdx] !== undefined) {
                  ta.value = resp.answers[qIdx];
              }
           }
        });
      }

      const raw = localStorage.getItem(cacheKey);
      const cache = raw ? JSON.parse(raw) : {};

      // Restore text fields
      if (mode === 'basic_design' && cache.fields) {
        body.querySelectorAll('.ds-question-input:not(.ds-element-note-input)').forEach(ta => {
          const ic = ta.dataset.itemCode;
          const qi = ta.dataset.cacheKey || ta.dataset.questionIdx;
          if (!ic || !qi || !cache.fields[ic]) return;
          if (cache.fields[ic][qi] !== undefined) {
            ta.value = cache.fields[ic][qi];
            return;
          }
          const legacyKey = ta.dataset.questionIdx;
          if (legacyKey !== undefined && cache.fields[ic][legacyKey] !== undefined) {
            ta.value = cache.fields[ic][legacyKey];
          }
        });
        // Restore design element card notes
        if (cache.elements) {
          body.querySelectorAll('.ds-element-note-input').forEach(ta => {
            const ck = ta.dataset.cacheKey;
            if (!ck || cache.elements[ck] === undefined) return;
            ta.value = cache.elements[ck];
          });
        }
      } else if (mode === 'custom_quote' && cache.fields) {
        Object.entries(cache.fields).forEach(([id, val]) => {
          const el = document.getElementById(id);
          if (el) el.value = val;
        });
      }

      try {
        const fileRaw = sessionStorage.getItem(fileCacheKey);
        if (fileRaw) {
          const fileCache = JSON.parse(fileRaw);
          const state = window._designSidebar;

          const serverSavedUrls = new Set();
          if (window.SAVED_DESIGN_RESPONSES) {
            Object.values(window.SAVED_DESIGN_RESPONSES).forEach(resp => {
              (resp.attachments || []).forEach(u => u && serverSavedUrls.add(u));
            });
          }

          Object.entries(fileCache).forEach(([key, files]) => {
            if (!files || !files.length) return;
            const uploadTarget = _resolveUploadTargetForRestore(mode, body, key);
            const resolvedKey = uploadTarget.key || key;
            if (!state.pendingFiles.has(resolvedKey)) state.pendingFiles.set(resolvedKey, []);
            const previewContainer = uploadTarget.previewContainer;
            const displayType = previewContainer?.dataset.displayType || 'thumb';

            files.forEach(f => {
              const uploadedUrl = f.uploaded_url || f.file_url || '';
              if (uploadedUrl && serverSavedUrls.has(uploadedUrl)) return;

              const existingList = state.pendingFiles.get(resolvedKey);
              let metaToRender = existingList.find(existingFile =>
                existingFile.id === f.id || ((existingFile.dataurl || '') && (f.dataurl || '') && existingFile.dataurl === f.dataurl)
              );

              if (!metaToRender) {
                const fileObj = _dataUrlToFile(f.dataurl, f.name);
                metaToRender = {
                  id: f.id, file: fileObj, dataurl: f.dataurl, name: f.name,
                  size: Number(f.size || fileObj.size || 0), status: f.status || 'Ready',
                  parentItemCode: f.parentItemCode || '',
                  uploaded_url: f.uploaded_url || '',
                  file_url: f.file_url || ''
                };
                existingList.push(metaToRender);
              }

              if (!previewContainer) return;

              const urlToRender = metaToRender.dataurl || metaToRender.uploaded_url || metaToRender.file_url || '';
              if (urlToRender && previewContainer.querySelector(`[data-url="${CSS.escape(urlToRender)}"]`)) {
                return;
              }

              previewContainer.appendChild(
                _buildUploadPreviewItem(resolvedKey, metaToRender, displayType, mode, body)
              );
            });
          });
        }
      } catch (e) { /* sessionStorage unavailable or corrupt */ }
      
      // Populate existing attachments from the main page if they are not in sessionStorage
      try {
        const itemCode = _getItemCode();
        if (itemCode) {
          const state = window._designSidebar;
          const bundleItems = window._designSidebar.bundleData || [];
          const selectedAddons = window._designSidebar.selectedAddons || [];
          
          if (window.SAVED_DESIGN_RESPONSES) {
            const childCodes = [itemCode];
            bundleItems.forEach(b => childCodes.push(b.item_code));
            selectedAddons.forEach(a => childCodes.push(a.item_code));

            const formIndexStr = body.dataset.designFormIndex || '0';
            const formIndexSuffix = body.dataset.designFormIndex ? '__idx_' + body.dataset.designFormIndex : '';

            childCodes.forEach(ic => {
              const response = window.SAVED_DESIGN_RESPONSES[`${ic}__${formIndexStr}`] || window.SAVED_DESIGN_RESPONSES[ic];
              if (!response || !response.attachments || !response.attachments.length) return;

              let uploadKey = 'main-' + ic;
              if (mode === 'artwork') {
                 if (ic === itemCode) uploadKey = 'main-' + ic + formIndexSuffix;
                 else if (bundleItems.some(b => b.item_code === ic)) uploadKey = 'bundle-' + ic + formIndexSuffix;
                 else if (selectedAddons.some(a => a.item_code === ic)) uploadKey = 'addon-artwork-' + ic + formIndexSuffix;
              } else {
                 if (ic === itemCode) uploadKey = 'main-' + ic + formIndexSuffix;
                 else if (bundleItems.some(b => b.item_code === ic)) uploadKey = 'bundle-' + ic + formIndexSuffix;
                 else if (selectedAddons.some(a => a.item_code === ic)) uploadKey = 'addon-basic-' + ic + formIndexSuffix;
              }

              const resolvedTarget = _resolveUploadTargetForRestore(mode, body, uploadKey);
              const resolvedKey = resolvedTarget.key || uploadKey;
              const previewContainer = resolvedTarget.previewContainer;
              const displayType = previewContainer?.dataset.displayType || 'thumb';

              if (!state.pendingFiles.has(resolvedKey)) state.pendingFiles.set(resolvedKey, []);

              response.attachments.forEach(url => {
                if (window._removedAttachments && window._removedAttachments.has(url)) return;
                const existingList = state.pendingFiles.get(resolvedKey);
                const exists = existingList.some(f =>
                  f.file_url === url || f.uploaded_url === url || f.dataurl === url
                );
                if (!exists) {
                  const filename = url.split('/').pop();
                  const fileMeta = {
                    id: `existing-${Date.now()}-${Math.random()}`,
                    file: new File([], filename),
                    dataurl: url,
                    file_url: url,
                    name: filename,
                    size: 0,
                    status: 'Ready',
                    parentItemCode: itemCode
                  };
                  existingList.push(fileMeta);
                  if (previewContainer) {
                    const urlToCheck = url;
                    if (!previewContainer.querySelector(`[data-url="${CSS.escape(urlToCheck)}"]`)) {
                      previewContainer.appendChild(
                        _buildUploadPreviewItem(resolvedKey, fileMeta, displayType, mode, body)
                      );
                    }
                  }
                }
              });
            });
          }
        }
      } catch (e) { console.error('Error restoring existing attachments', e); }

      if (mode === 'basic_design') {
        _refreshDesignElementsState(body);
      }
      if (cache.submitted) {
        _markButtonSubmitted(mode);
        _enterEditMode(mode);
      }
    } catch (e) { /* corrupt cache */ }
  }

  function _clearCache(mode) {
    try { localStorage.removeItem(_cacheKey(mode)); } catch (e) { }
    try { sessionStorage.removeItem(_fileCacheKey(mode)); } catch (e) { }
  }

  // Clear all design sidebar caches for a specific item (called on add-to-cart)
  function _clearItemDesignCaches(itemCode) {
    if (!itemCode) return;
    const modes = ['artwork', 'basic_design', 'custom_quote'];
    modes.forEach(mode => {
      const key = _cacheKey(mode, itemCode);
      const fileKey = _fileCacheKey(mode, itemCode);
      try { localStorage.removeItem(key); } catch (e) { }
      try { sessionStorage.removeItem(fileKey); } catch (e) { }
      _unmarkButtonSubmitted(mode);
    });
    window._designSidebar.designFormIndex = 0;
  }

  // Public API for add-to-cart integration
  window.clearDesignSidebarCacheForItem = function (itemCode) {
    _clearItemDesignCaches(itemCode);
  };

  function _markCacheSubmitted(mode) {
    try {
      const raw = localStorage.getItem(_cacheKey(mode));
      const cache = raw ? JSON.parse(raw) : { fields: {} };
      cache.submitted = true;
      localStorage.setItem(_cacheKey(mode), JSON.stringify(cache));
    } catch (e) { }
  }

  function _enterEditMode(mode) {
    const body = document.getElementById('design-sidebar-body');
    if (!body) return;

    // Add submitted notice banner if not already present
    if (!body.querySelector('.ds-submitted-notice')) {
      const notice = document.createElement('div');
      notice.className = 'ds-submitted-notice';
      notice.style.cssText = 'display:flex;align-items:center;gap:8px;background:#f0fdf4;border:1px solid green;border-radius:6px;padding:8px 12px;margin-bottom:14px;font-size:0.82rem;color:#166534;';
      notice.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
        '<span>Previously submitted &mdash; any changes will overwrite your last submission.</span>';
      body.insertBefore(notice, body.firstChild);
    }

    if (mode === 'basic_design') {
      const actions = body.querySelector('.ds-basic-actions');
      if (actions) {
        const submitBtn = actions.querySelector('.ds-submit-btn[data-action="submit"]') || actions.querySelector('.ds-submit-btn');
        if (submitBtn) {
          submitBtn.textContent = 'Save Changes';
          submitBtn.dataset.defaultLabel = 'Save Changes';
        }

        // if (!actions.querySelector('.ds-cancel-edit-btn')) {
        //   const cancelBtn = document.createElement('button');
        //   cancelBtn.type = 'button';
        //   cancelBtn.className = 'ds-cancel-edit-btn';
        //   cancelBtn.textContent = 'Cancel';
        //   cancelBtn.onclick = () => closeDesignSidebar();
        //   actions.appendChild(cancelBtn);
        // }
        return;
      }
    }

    // Swap the submit button for Save + Cancel
    const submitBtn = body.querySelector('.ds-submit-btn');
    if (!submitBtn || submitBtn.closest('.ds-edit-btn-group')) return;

    const btnGroup = document.createElement('div');
    btnGroup.className = 'ds-edit-btn-group ds-sidebar-footer';
    btnGroup.style.cssText = 'display:flex; gap:10px; margin-top:8px; position:relative;';

    const saveBtn = document.createElement('button');
    saveBtn.type = 'button';
    saveBtn.className = 'ds-submit-btn';
    saveBtn.style.cssText = 'flex:1; margin-top:0; font-size: 1rem;';
    saveBtn.textContent = 'Save Changes';
    saveBtn.onclick = function() { submitDesignSidebar(this); };

    // const cancelBtn = document.createElement('button');
    // cancelBtn.type = 'button';
    // cancelBtn.className = 'ds-cancel-edit-btn';
    // cancelBtn.style.cssText = 'flex:1;padding:10px 16px; border-radius:6px; border:1px solid black; background:#fff;color:black;font-size:1rem;font-weight:600;cursor:pointer; box-shadow: 4px 4px 0 0 black; transition:all 0.2s ease; ';
    // cancelBtn.textContent = 'Cancel';
    // cancelBtn.onmouseover = () => { cancelBtn.style.boxShadow = 'none'; cancelBtn.style.transform = 'translate(4px, 4px)'; };
    // cancelBtn.onmouseout = () => { cancelBtn.style.boxShadow = '4px 4px 0 0 black'; cancelBtn.style.transform = 'translate(0, 0)'; };
    // cancelBtn.onclick = () => closeDesignSidebar();

    btnGroup.appendChild(saveBtn);
    submitBtn.replaceWith(btnGroup);
  }

  // Collect uploads for a given key
  function _collectUploads(uploadedUrls, key) {
    const urls = [];

    Object.entries(uploadedUrls || {}).forEach(([k, arr]) => {
      const match = (k === key) || (!key.includes('__idx_') && k.startsWith(key + '__idx_'));
      if (!match) return;
      (arr || []).forEach((u) => u && urls.push(u));
    });

    if (window._designSidebar.mode !== 'basic_design') {
      return [...new Set(urls)];
    }

    const generated = window._designSidebar.generatedDesignUrls;
    if (!generated) {
      return [...new Set(urls)];
    }

    generated.forEach((arr, k) => {
      const match = (k === key) || (!key.includes('__idx_') && k.startsWith(key + '__idx_'));
      if (!match) return;
      (arr || []).forEach((u) => u && urls.push(u));
    });

    return [...new Set(urls)];
  }

  function _isPersistedDesignFileUrl(url) {
    if (!url || typeof url !== 'string') return false;
    if (url.startsWith('blob:') || url.startsWith('data:')) return false;
    return url.startsWith('/files/') || url.startsWith('/private/files/') || /^https?:\/\//i.test(url);
  }

  function _mergePendingUploadedUrls(uploadedUrlsByKey) {
    const merged = { ...(uploadedUrlsByKey || {}) };
    const state = window._designSidebar;
    if (!state || !state.pendingFiles) return merged;

    state.pendingFiles.forEach((files, key) => {
      if (!merged[key]) merged[key] = [];
      (files || []).forEach((fileObj) => {
        const url = fileObj.uploaded_url || fileObj.file_url || '';
        if (_isPersistedDesignFileUrl(url)) merged[key].push(url);
      });
      merged[key] = [...new Set(merged[key].filter(Boolean))];
    });

    return merged;
  }

  function _itemCodeFromUploadKey(key, fallbackItemCode) {
    if (!key) return fallbackItemCode;
    if (key.includes('__idx_')) {
      key = key.split('__idx_')[0];
    }
    if (key.startsWith('main-')) return key.slice(5);
    if (key.startsWith('bundle-')) return key.slice(7);
    if (key.startsWith('addon-basic-')) return key.slice(12);
    if (key.startsWith('addon-artwork-')) return key.slice(14);
    return fallbackItemCode;
  }

  function _collectPersistedPreviewUrls(previewNode) {
    const urls = [];
    if (!previewNode) return urls;

    previewNode.querySelectorAll('[data-url]').forEach((node) => {
      const url = node.dataset.url || '';
      if (!_isPersistedDesignFileUrl(url)) return;
      if (window._removedAttachments && window._removedAttachments.has(url)) return;
      urls.push(url);
    });

    return [...new Set(urls)];
  }

  function _getLogoUploadUrl(uploadedUrls) {
    const logos = _collectUploads(uploadedUrls, 'logo');
    return logos.length ? logos[logos.length - 1] : '';
  }

  function _getLogoUploadUrls(uploadedUrls) {
      return _collectUploads(uploadedUrls, 'logo');
  }

  function _getDesignLogoUrls(form, uploadedUrlsByKey) {
    let urls = [];
    const section = (form ? form.querySelector('[data-design-logo-section]') : null) || document.querySelector('[data-design-logo-section]');
    if (section && section.dataset.existingLogoUrls) {
      try {
        urls = JSON.parse(section.dataset.existingLogoUrls);
      } catch(e) {}
    }
    const newLogos = _getLogoUploadUrls(uploadedUrlsByKey);
    const allUrls = [...urls, ...(newLogos || [])];
    return [...new Set(allUrls.filter(u => u && !(window._removedAttachments && window._removedAttachments.has(u))))];
  }
  window._getDesignLogoUrls = _getDesignLogoUrls;

  function _getDesignAdditionalFileUrls(form, uploadedUrlsByKey) {
    let urls = [];
    const section = (form ? form.querySelector('[data-design-additional-files-section]') : null) || document.querySelector('[data-design-additional-files-section]');
    if (section && section.dataset.existingAdditionalFilesUrls) {
      try {
        urls = JSON.parse(section.dataset.existingAdditionalFilesUrls);
      } catch(e) {}
    }
    const newFiles = _collectUploads(uploadedUrlsByKey, 'additional_files');
    const allUrls = [...urls, ...(newFiles || [])];
    return [...new Set(allUrls.filter(u => u && !(window._removedAttachments && window._removedAttachments.has(u))))];
  }
  window._getDesignAdditionalFileUrls = _getDesignAdditionalFileUrls;

  // On page load, check localStorage for submitted forms for the CURRENT item only and mark their choice buttons.
  function _restoreSubmittedBadges() {
    const itemCode = _getItemCode();
    if (!itemCode) return;
    const modes = ['artwork', 'basic_design', 'custom_quote'];
    modes.forEach(mode => {
      try {
        const raw = localStorage.getItem(_cacheKey(mode, itemCode));
        if (!raw) return;
        const cache = JSON.parse(raw);
        if (cache && cache.submitted) _markButtonSubmitted(mode);
      } catch (e) { /* corrupt cache */ }
    });
  }

  function _renderDesignItemAccordion(opts) {
    const {
      title,
      htmlTitle,
      itemCode,
      description,
      templates,
      questions,
      isOpen,
      uploadKey,
      badge,
      accordionClass,
      includeUploads,
      uploadSectionHtml
    } = opts;

    let html = '';
    if (badge) {
      const wrapperClass = accordionClass || 'ds-accordion-addon';
      html += `<div class="${wrapperClass}"><span class="ds-accordion-badge">${badge}</span>`;
    }

    html += `<div class="ds-accordion">`;
    html += _buildAccordionHeader(title, isOpen, htmlTitle);
    html += `<div class="ds-accordion-body ${isOpen ? 'show' : ''}">`;

    // if (description) {
    //   html += `<p class="ds-item-desc">${_escapeHtml(description)}</p>`;
    // }

    if (!opts.hideTemplates) {
      html += `<div class="ds-section-title">Templates</div>`;
      if (!templates || !templates.length) {
        html += `<p class="ds-empty-note">No downloadable templates found for this item.</p>`;
      } else {
        templates.forEach((tpl) => {
          let templateUrl = tpl.template || '#';
          for (const p of ['/assets/', '/files/']) {
            const idx = templateUrl.indexOf(p);
            if (idx !== -1) { templateUrl = templateUrl.substring(idx); break; }
          }
          const templateLabel = _escapeHtml(tpl.file_name || 'Download Design Template');
          html += `
            <div>
              <small class="text-muted"> These are reference files provided for your convenience. </small>
            </div>
            <div class="ds-template-row" style="margin-bottom:12px;">
              <a href="${templateUrl}" target="_blank" class="ds-template-link" download="${templateLabel}" data-filename="${templateLabel}">
                <i class="fa fa-download"></i> ${templateLabel}
              </a>
            </div>
          `;
        });
      }
    }

    // Design element cards (may be empty — module will handle visibility)
    const designElements = Array.isArray(opts.designElements) ? opts.designElements : [];
    const activeSizeOption = opts.activeSizeOption || '';
    const activeAttributeOptions = opts.activeAttributeOptions || {};
    if (designElements.length) {
      html += _renderDesignElementsPanel({
        title: title,
        itemCode: itemCode,
        designElements,
        uploadKey: uploadKey,
        activeSizeOption,
        activeAttributeOptions,
      });
    }

    const designQuestions = Array.isArray(opts.designQuestions) ? opts.designQuestions : [];
    const generalQuestions = Array.isArray(questions) ? questions : [];
    const hideGeneral = !!opts.hideGeneralQuestions;

    const renderDesignSection = designQuestions.length > 0;
    const renderGeneralSection = !hideGeneral && generalQuestions.length > 0;

    if (itemCode === 'VP') {
      if (uploadSectionHtml !== undefined) {
        html += uploadSectionHtml;
      } else if (includeUploads !== false) {
        html += _buildUploadSection(uploadKey, {
          label: 'Upload the files you want vectorized',
          buttonText: '+ Add Files'
        });
      }
      
      html += _buildQuestionsHtml([{ question: 'Instructions (If any)' }], itemCode, { startIndex: 0, cacheKeyPrefix: 'vp-instruction' });
    } else {
      if (renderDesignSection) {
        html += `<div class="ds-section-title" style="margin-top:10px;">Design Questions</div>`;
        html += _buildQuestionsHtml(designQuestions, itemCode, { startIndex: 0, cacheKeyPrefix: 'design-question' });
      }

      if (renderGeneralSection) {
        html += `<div class="ds-section-title" style="margin-top:10px;">General Questions</div>`;
        html += _buildQuestionsHtml(generalQuestions, itemCode, { startIndex: designQuestions.length, cacheKeyPrefix: 'general-question' });
      }

      if (uploadSectionHtml !== undefined) {
        html += uploadSectionHtml;
      } else if (includeUploads !== false) {
        html += _buildUploadSection(uploadKey, {
          label: 'General Uploads',
          buttonText: '+ Add Files'
        });
      }
    }
    // html += _buildGenerateDesignBlock(itemCode, uploadKey);
    html += `</div></div>`;

    if (badge) html += `</div>`;
    return html;
  }

  window.DesignSidebarApi = window.DesignSidebarApi || {};
  window.DesignSidebarApi.fetchDesignSidebarData = _fetchDesignSidebarData;
  window.DesignSidebarApi.renderDesignItemAccordion = _renderDesignItemAccordion;
  window.DesignSidebarApi.renderTemplatesAccordion = _renderTemplatesAccordion;
  window.DesignSidebarApi.initAccordions = _initAccordions;
  window.DesignSidebarApi.isDesignFormMainOnly = function () {
    return DESIGN_FORM_MAIN_ONLY;
  };
  window.DesignSidebarApi.buildUploadSection = _buildUploadSection;
  window.DesignSidebarApi.buildUploadPreviewItem = _buildUploadPreviewItem;
  window.DesignSidebarApi.uploadPendingFiles = _uploadPendingFiles;
  window.DesignSidebarApi.flattenBundleItems = _flattenBundleItems;
  window.DesignSidebarApi.isHiddenInDesignForm = _isHiddenInDesignForm;
  window.DesignSidebarApi.renderDesignElementsPanel = _renderDesignElementsPanel;
  // Expose loader used by the sidebar so other pages can reuse the same rendering logic.
  window.DesignSidebarApi.loadBasicDesignMode = _loadBasicDesignMode;
  window.DesignSidebarApi.loadArtworkMode = _loadArtworkMode;
  window.DesignSidebarApi.loadCustomQuoteMode = _loadCustomQuoteMode;
  window.DesignSidebarApi.renderCustomQuoteForm = _buildCustomQuoteFormHtml;
  window.DesignSidebarApi.attachBasicDesignInteractions = _attachBasicDesignInteractions;
  window.DesignSidebarApi.openDesignFileUploader = _openDesignFileUploader;
  window.DesignSidebarApi.openPreviewImageModal = _openPreviewImageModal;

  function _buildGenerateDesignBlock(itemCode, uploadKey) {
    return `
      <div class="ds-ai-generate-block" data-item-code="${itemCode}" data-upload-key="${uploadKey}">
        <button type="button" class="secondary-btn btn-md btn-full" onclick="generateDesignForItem(this)">
          <i class="fa fa-magic"></i> Generate Design
        </button>
        <div class="ds-ai-powered-label">Powered by Google Gemini</div>
        <div class="ds-ai-result" data-item-code="${itemCode}"></div>
      </div>
    `;
  }

  function _collectItemQuestionAnswers(itemCode) {
    if (!itemCode) return [];

    const answers = [];

    const questionNodes = document.querySelectorAll(`.ds-question-input[data-item-code="${itemCode}"]:not(.ds-element-note-input)`);
    Array.from(questionNodes).forEach((ta) => {
      const row = ta.closest('.ds-question-row');
      const question = row?.querySelector('.ds-question-title')?.textContent?.trim() || '';
      answers.push({
        question,
        answer: (ta.value || '').trim()
      });
    });

    const elementNodes = document.querySelectorAll(`.ds-element-note-input[data-item-code="${itemCode}"]`);
    Array.from(elementNodes).forEach((ta) => {
      const elementName = (ta.dataset.elementName || 'Design Element').trim();
      answers.push({
        question: `Design Element: ${elementName}`,
        answer: (ta.value || '').trim()
      });
    });

    return answers.filter((x) => x.question);
  }

  window.generateDesignForItem = async function (btn) {
    const state = window._designSidebar;
    if (!state || state.mode !== 'basic_design') {
      frappe.msgprint({
        title: __('Not Allowed'),
        message: __('AI design generation is available only in Basic Design mode.'),
        indicator: 'orange'
      });
      return;
    }

    const wrap = btn.closest('.ds-ai-generate-block');
    if (!wrap) return;

    const itemCode = (wrap.dataset.itemCode || '').trim();
    const uploadKey = (wrap.dataset.uploadKey || '').trim();
    if (!itemCode || !uploadKey) return;

    const resultBox = wrap.querySelector('.ds-ai-result');
    btn.disabled = true;
    btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Generating...';

    try {
      const bundleSource = (state.bundleData || []).find((x) => x.item_code === itemCode);
      const mainSource = state.productData && state.productData.item_code === itemCode ? state.productData : null;
      const source = bundleSource || mainSource || {};
      const payload = {
        item_code: itemCode,
        item_name: source.item_name || source.description || itemCode,
        description: source.description || source.item_description || '',
        templates: source.downloadable_templates || source.product_templates || [],
        question_answers: _collectItemQuestionAnswers(itemCode),
      };

      const r = await frappe.call({
        method: 'klaviyo_integration.www.design_form.index.generate_design_for_sidebar_item',
        args: { item_payload_json: JSON.stringify(payload) }
      });

      const m = r && r.message;
      if (!m || m.status !== 'success' || !m.file_url) {
        throw new Error('Generation failed');
      }

      if (!state.generatedDesignUrls.has(uploadKey)) {
        state.generatedDesignUrls.set(uploadKey, []);
      }
      state.generatedDesignUrls.get(uploadKey).push(m.file_url);

      resultBox.innerHTML = `
        <a href="${m.file_url}" target="_blank" class="ds-template-link">
          <i class="fa fa-image"></i> ${m.file_name || 'AI Design'}
        </a>
        <div class="ds-ai-powered-label">${m.powered_by || 'Powered by Google Gemini'}</div>
      `;
    } catch (e) {
      frappe.msgprint({
        title: __('Error'),
        message: __('Failed to generate design. Please try again.'),
        indicator: 'red'
      });
    } finally {
      btn.disabled = false;
      btn.innerHTML = '<i class="fa fa-magic"></i> Generate Design';
    }
  };

  window.save_design_form_responses = async function (btn) {
    const form = btn.closest('form');
    if (!form) return;

    const shouldSubmit = btn.dataset.submitResponse === '1';
    const designMode = form.querySelector('[name="design_mode"]')?.value
      || (window._designSidebar && window._designSidebar.mode)
      || 'basic_design';
    if (shouldSubmit) {
      const confirmMessage = designMode === 'artwork'
        ? __('This will submit your artwork files and redirect you to your quotation to confirm your order. Do you want to continue?')
        : __('Once submitted, you will not be able to edit the design form responses. Only the Additional Notes section will remain editable. Do you want to submit now?');
      const confirmed = await showCustomConfirm(
        __('Confirm Submission'),
        confirmMessage,
        [
          { text: __('Cancel'), value: false, primary: false },
          { text: __('Continue'), value: true, primary: true }
        ]
      );
      if (!confirmed) return;
    }

    btn.disabled = true;
    const defaultLabel = btn.dataset.defaultLabel || (shouldSubmit ? 'Submit Design Form' : 'Save All');
    btn.innerHTML = `<i class="fa fa-spinner fa-spin"></i> ${shouldSubmit ? 'Submitting...' : 'Saving...'}`;

    try {
      if (designMode === 'basic_design') {
        const pendingMocks = {};
        if (window._designSidebar && window._designSidebar.pendingFiles) {
          window._designSidebar.pendingFiles.forEach((files, k) => {
            if (files && files.length) pendingMocks[k] = ['pending'];
          });
        }
        const tempLogos = _getDesignLogoUrls(form, pendingMocks);
        if (!tempLogos || tempLogos.length === 0) {
          const confirmed = await showCustomConfirm(
            __('Missing Logo'),
            __('You have not added any logos. Are you sure you want to continue without a logo?'),
            [
              { text: __('Cancel'), value: false, primary: false },
              { text: __('Continue'), value: true, primary: true }
            ]
          );
          if (!confirmed) {
            btn.disabled = false;
            btn.innerHTML = defaultLabel;
            return;
          }
        }
      }

      const api = window.DesignSidebarApi;
      let uploadedUrlsByKey = api && typeof api.uploadPendingFiles === 'function'
        ? await api.uploadPendingFiles()
        : {};
      uploadedUrlsByKey = _mergePendingUploadedUrls(uploadedUrlsByKey);
      const logoUrls = _getDesignLogoUrls(form, uploadedUrlsByKey);
      const additionalFileUrls = _getDesignAdditionalFileUrls(form, uploadedUrlsByKey);

      const items_data = [];
      const salesOrder = form.querySelector('[name="sales_order"]')?.value || '';
      const quotation = form.querySelector('[name="quotation"]')?.value || '';
      const additionalNotesField = form.querySelector('[name="additional_notes"]');
      const additionalNotes = additionalNotesField ? additionalNotesField.value : '';

      const itemCards = form.querySelectorAll('.item-card');

      if (designMode === 'custom_quote') {
        const quoteFields = [
          ['Full Name', document.getElementById('ds-cq-name')?.value || ''],
          ['Email', document.getElementById('ds-cq-email')?.value || ''],
          ['Phone', document.getElementById('ds-cq-phone')?.value || ''],
          ['Organization', document.getElementById('ds-cq-company')?.value || ''],
          ['Subject', document.getElementById('ds-cq-subject')?.value || ''],
          ['Message', document.getElementById('ds-cq-message')?.value || ''],
        ];
        const requiredQuoteFields = quoteFields.filter(([label]) =>
          label === 'Full Name' || label === 'Email' || label === 'Subject' || label === 'Message'
        );
        const missingQuoteFields = requiredQuoteFields.filter(([, value]) => !(value || '').trim());
        if (missingQuoteFields.length) {
          frappe.msgprint({
            title: __('Missing Fields'),
            message: __('Please fill in all required custom quote fields.'),
            indicator: 'orange'
          });
          btn.disabled = false;
          btn.innerHTML = defaultLabel;
          return;
        }

        const quoteItems = [];
        itemCards.forEach((card, cardIdx) => {
          const itemName = card.querySelector('[name="item_name[]"]')?.value || '';
          const itemCode = card.querySelector('[name="item_code[]"]')?.value || '';
          const itemGroup = card.querySelector('[name="item_group[]"]')?.value || '';

          quoteItems.push({
            item_name: itemName || itemCode,
            item_code: itemCode,
            item_group: itemGroup,
            questions: cardIdx === 0 ? quoteFields.map(([label]) => label) : [],
            answers: cardIdx === 0 ? quoteFields.map(([, value]) => (value || '').trim()) : [],
            uploaded_images: cardIdx === 0 ? _collectUploads(uploadedUrlsByKey, 'custom-quote') : [],
            design_mode: 'custom_quote'
          });
        });

        if (quoteItems.length) {
          items_data.push(quoteItems);
        }
      }

      if (designMode !== 'custom_quote') for (const card of itemCards) {
        const itemName = card.querySelector('[name="item_name[]"]')?.value || '';
        const itemCode = card.querySelector('[name="item_code[]"]')?.value || '';
        const itemGroup = card.querySelector('[name="item_group[]"]')?.value || '';

        const accordionWrap = card.querySelector('.ds-design-form-accordions');
        const primaryQtyStr = accordionWrap ? accordionWrap.dataset.qty : '1';
        const primaryQty = parseInt(primaryQtyStr) || 1;
        const itemIdx = accordionWrap ? accordionWrap.dataset.itemIdx : null;
        const designFormIndexStr = accordionWrap ? accordionWrap.dataset.designFormIndex : null;
        const designFormIndex = designFormIndexStr ? parseInt(designFormIndexStr) : 0;
        
        const _getBundleQty = (code) => {
            const bData = window._designSidebar?.productData?.bundle_items || [];
            const flatten = (items) => items.reduce((acc, i) => acc.concat(i, flatten(i.children || [])), []);
            const allBundles = flatten(bData);
            const found = allBundles.find(b => b.item_code === code);
            return found ? (parseInt(found.qty) || 1) : 1;
        };

        const itemMap = new Map();
        const ensureItem = (code) => {
          const normalizedCode = code || itemCode;
          if (!itemMap.has(normalizedCode)) {
            itemMap.set(normalizedCode, {
              item_name: normalizedCode === itemCode ? itemName : normalizedCode,
              item_code: normalizedCode,
              parent_item_code: normalizedCode === itemCode ? '' : itemCode,
              item_group: normalizedCode === itemCode ? itemGroup : '',
              qty: normalizedCode === itemCode ? primaryQty : (primaryQty * _getBundleQty(normalizedCode)),
              is_simple_mode: window._designFormSimpleModes && window._designFormSimpleModes[normalizedCode] ? 1 : 0,
              simple_instructions: '',
              questions: [],
              answers: [],
              uploaded_images: [],
              design_form_index: designFormIndex
            });
          }
          return itemMap.get(normalizedCode);
        };
        const addQa = (code, question, answer) => {
          if (!question) return;
          const target = ensureItem(code);
          target.questions.push(question);
          target.answers.push((answer || '').trim());
        };
        if (designMode === 'artwork') {
          ensureItem(itemCode);

          if (accordionWrap) {
            accordionWrap.querySelectorAll('.ds-upload-preview[data-upload-key]').forEach(node => {
              const uploadKey = (node.dataset.uploadKey || '').trim();
              if (!uploadKey) return;

              const targetCode = _itemCodeFromUploadKey(uploadKey, itemCode);
              const target = ensureItem(targetCode);
              target.uploaded_images.push(
                ..._collectUploads(uploadedUrlsByKey, uploadKey),
                ..._collectPersistedPreviewUrls(node)
              );
            });
          }

          card.querySelectorAll('.existing-attachment').forEach(div => {
            const existingCode = div.dataset.itemCode || itemCode;
            if (div.style.display !== 'none' || div.classList.contains('saved-attachment-preserve')) {
              const url = div.dataset.url;
              if (url && (!window._removedAttachments || !window._removedAttachments.has(url))) {
                const target = ensureItem(existingCode);
                target.uploaded_images.push(url);
              }
            }
          });

          if (itemMap.size) {
            items_data.push(Array.from(itemMap.values()).map((item) => ({
              ...item,
              uploaded_images: [...new Set(item.uploaded_images)],
              design_mode: 'artwork'
            })));
          }
          continue;
        }

        ensureItem(itemCode);
        if (accordionWrap) {
          accordionWrap.querySelectorAll('.ds-question-input:not(.ds-element-note-input)').forEach((ta) => {
            const row = ta.closest('.ds-question-row');
            const qTitle = row ? (row.querySelector('.ds-question-title')?.textContent || '').trim() : '';
            const ic = ta.dataset.itemCode || itemCode;
            const isSimple = window._designFormSimpleModes && window._designFormSimpleModes[itemCode];
            if (isSimple && ic === itemCode && qTitle === 'Enter your instructions') {
              ensureItem(ic).simple_instructions = ta.value;
            } else {
              addQa(ic, qTitle, ta.value);
            }
          });

          accordionWrap.querySelectorAll('.ds-element-note-input').forEach((ta) => {
            const eName = (ta.dataset.elementName || 'Design Element').trim();
            addQa(ta.dataset.itemCode || itemCode, `Design Element: ${eName}`, ta.value);
          });

        }

        const primaryItem = ensureItem(itemCode);
        if (!primaryItem.questions.length && !primaryItem.answers.length && itemIdx != null) {
          form.querySelectorAll(`[name="answer_${itemIdx}[]"]`).forEach(el => primaryItem.answers.push(el.value));
          form.querySelectorAll(`[name="question_text_${itemIdx}[]"]`).forEach(el => primaryItem.questions.push(el.value));
        }

        card.querySelectorAll('.existing-attachment').forEach(div => {
          if (div.style.display !== 'none' || div.classList.contains('saved-attachment-preserve')) {
            const url = div.dataset.url;
            if (!window._removedAttachments || !window._removedAttachments.has(url)) {
              const attachmentItem = ensureItem(div.dataset.itemCode || itemCode);
              attachmentItem.uploaded_images.push(url);
            }
          }
        });

        if (accordionWrap) {
          accordionWrap.querySelectorAll('.ds-upload-preview[data-upload-key]').forEach(node => {
            const key = (node.dataset.uploadKey || '').trim();
            if (!key) return;
            const uploadItem = ensureItem(_itemCodeFromUploadKey(key, itemCode));
            if (uploadedUrlsByKey[key]) {
              uploadItem.uploaded_images.push(...uploadedUrlsByKey[key]);
            }
            uploadItem.uploaded_images.push(..._collectPersistedPreviewUrls(node));
          });
        }

        items_data.push(Array.from(itemMap.values()).map((item) => ({
          ...item,
          uploaded_images: [...new Set(item.uploaded_images)]
        })));
      }

      let artworkRedirectUrl = window.DESIGN_FORM_ARTWORK_ORDER_CONFIRM_URL || '';
      const allItemsData = items_data.flat();
      if (allItemsData.length > 0) {
        const formData = new FormData();
        if (salesOrder) formData.append('sales_order', salesOrder);
        if (quotation) formData.append('quotation', quotation);
        if (designMode) formData.append('design_mode', designMode);

        formData.append('items_data', JSON.stringify(allItemsData));
        formData.append('design_form_url', window.location.href);
        if (logoUrls.length) {
            formData.append('logo_urls', JSON.stringify(logoUrls));
            formData.append('logo_url', logoUrls[0]);
        } else {
            formData.append('logo_urls', '[]');
            formData.append('logo_url', '');
        }
        
        if (additionalFileUrls.length) {
            formData.append('additional_files', JSON.stringify(additionalFileUrls));
        } else {
            formData.append('additional_files', '[]');
        }
        
        if (additionalNotesField) formData.append('additional_notes', additionalNotes);
        if (shouldSubmit) formData.append('submit_response', '1');

        const response = await fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Frappe-CSRF-Token': frappe.csrf_token
          }
        });

        if (!response.ok) {
          throw new Error('Failed to save an item');
        }

        const responseData = await response.json().catch(() => null);
        const message = responseData && responseData.message;
        if ((designMode === 'artwork' || designMode === 'basic_design') && message && message.order_confirm_url) {
          artworkRedirectUrl = message.order_confirm_url;
        }
      }

      frappe.msgprint({
        title: __('Success'),
        message: shouldSubmit ? __('Your responses have been submitted successfully!') : __('Your responses have been saved successfully!'),
        indicator: 'green'
      });

      try {
        if (typeof window.clearDesignFormUploadCache === 'function') {
          window.clearDesignFormUploadCache();
        }
        // Also clear all sidebar file session caches so that after reload,
        // saved files come from SAVED_DESIGN_RESPONSES and are not double-rendered.
        const modes = ['artwork', 'basic_design', 'custom_quote'];
        const allItemCodes = new Set([_getItemCode()].filter(Boolean));
        if (window._designSidebar) {
          (window._designSidebar.bundleData || []).forEach(b => b.item_code && allItemCodes.add(b.item_code));
          (window._designSidebar.selectedAddons || []).forEach(a => a.item_code && allItemCodes.add(a.item_code));
        }
        modes.forEach(m => {
          try { sessionStorage.removeItem(_fileCacheKey(m)); } catch (e) {}
          allItemCodes.forEach(ic => {
            try { sessionStorage.removeItem(_fileCacheKey(m, ic)); } catch (e) {}
          });
        });
      } catch (e) {}

      if (shouldSubmit && (designMode === 'artwork' || designMode === 'basic_design') && artworkRedirectUrl) {
        btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Redirecting...';
        const msgText = designMode === 'artwork' 
            ? __('Your artwork has been submitted. Redirecting you to your quotation to confirm your order...')
            : __('Your design has been submitted. Redirecting you to your quotation to confirm your order...');
        showCustomConfirm(
          __('Redirecting'),
          msgText,
          []
        );
        setTimeout(() => {
          window.location.href = artworkRedirectUrl;
        }, 1200);
        return;
      }

      setTimeout(() => window.location.reload(), 5000);

    } catch (error) {
      console.error('Submission error:', error);
      frappe.msgprint({
        title: __('Error'),
        message: __('Failed to save responses. Please try again.'),
        indicator: 'red'
      });
      btn.disabled = false;
      btn.innerHTML = defaultLabel;
    }
  };

  function showCustomConfirm(title, message, buttons) {
    return new Promise((resolve) => {
      const overlay = document.createElement('div');
      overlay.className = 'confirm-modal-overlay';
      
      const modal = document.createElement('div');
      modal.className = 'confirm-modal';
      
      const titleEl = document.createElement('div');
      titleEl.className = 'confirm-modal-title';
      titleEl.textContent = title;
      
      const closeBtn = document.createElement('button');
      closeBtn.className = 'confirm-modal-close';
      closeBtn.innerHTML = '&times;';
      closeBtn.onclick = () => {
          overlay.classList.remove('show');
          setTimeout(() => overlay.remove(), 300);
          resolve(null);
      };
      
      const bodyEl = document.createElement('div');
      bodyEl.className = 'confirm-modal-body';
      bodyEl.innerHTML = message;
      
      const actionsEl = document.createElement('div');
      actionsEl.className = 'confirm-modal-actions';
      
      buttons.forEach(btn => {
        const btnEl = document.createElement('button');
        btnEl.className = btn.primary ? 'primary-btn' : 'secondary-btn';
        btnEl.textContent = btn.text;
        btnEl.onclick = () => {
          overlay.classList.remove('show');
          setTimeout(() => overlay.remove(), 300);
          resolve(btn.value);
        };
        actionsEl.appendChild(btnEl);
      });
      
      modal.appendChild(closeBtn);
      modal.appendChild(titleEl);
      modal.appendChild(bodyEl);
      modal.appendChild(actionsEl);
      
      // Close on clicking outside
      overlay.onclick = (e) => {
          if (e.target === overlay) {
              overlay.classList.remove('show');
              setTimeout(() => overlay.remove(), 300);
              resolve(null);
          }
      };
      
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      
      // trigger reflow for transition
      void overlay.offsetWidth;
      overlay.classList.add('show');
    });
  }

  document.addEventListener('DOMContentLoaded', _restoreSubmittedBadges);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      _closePreviewImageModal();
    }
  });

})();
